import { a as s, c as p } from "./createOperation-Opo4US4u.js";
import { p as g, o as f, l as W, t as ae, w as se, c as le, b as ce, x as me, y as ue } from "./viewOptionQuery-CA9LgZQl.js";
const ge = s((e) => ({
  hasSubscription: !!(e != null && e.hasSubscription),
  billingFeatureNames: ((e == null ? void 0 : e.contentPackages) ?? []).map(
    ({ billingFeatureName: t }) => t
  )
})), pe = {
  name: "SubscriptionInfo",
  body: "query SubscriptionInfo { userProfile { subscriptionInfo { ...SubscriptionInfo } } } fragment SubscriptionInfo on SubscriptionInfo { hasSubscription contentPackages { billingFeatureName } }",
  get variables() {
  },
  get query() {
  }
}, to = p(pe, {
  resolve: (e) => {
    var t;
    return ((t = e == null ? void 0 : e.userProfile) == null ? void 0 : t.subscriptionInfo) ?? null;
  },
  hydrate: (e) => ge(e)
});
class I extends Error {
  constructor(t) {
    super(t), this.name = "MutationError";
  }
}
const de = {
  name: "UpdatePreferredWatchingLanguage",
  body: "mutation UpdatePreferredWatchingLanguage($code: String!) { userProfile { localisation { setPreferredWatchingLanguage(code: $code) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, ve = s(
  (e) => e
), no = p(
  de,
  {
    resolve: (e, t, n) => {
      var i, r, a;
      const o = (r = (i = e == null ? void 0 : e.userProfile) == null ? void 0 : i.localisation) == null ? void 0 : r.setPreferredWatchingLanguage;
      if ((o == null ? void 0 : o.status) === "FAIL")
        throw new I(
          ((a = o.error) == null ? void 0 : a.message) ?? "Failed to update preferred watching language"
        );
      return {
        preferredWatchingLanguage: (n == null ? void 0 : n.code) ?? null
      };
    },
    hydrate: ve
  }
), he = s(
  (e) => {
    var t, n, o, i;
    return {
      availableWatchingLanguages: ((n = (t = e.localisation) == null ? void 0 : t.languages) == null ? void 0 : n.availableWatchingLanguages) ?? [],
      preferredWatchingLanguage: ((i = (o = e.localisation) == null ? void 0 : o.languages) == null ? void 0 : i.preferredWatchingLanguage) ?? null
    };
  }
), fe = {
  name: "UserSettings",
  body: "query UserSettings { userProfile { localisation { languages { availableWatchingLanguages { title code } preferredWatchingLanguage { title code } } } } }",
  get variables() {
  },
  get query() {
  }
}, oo = p(fe, {
  resolve: (e) => e == null ? void 0 : e.userProfile,
  hydrate: (e) => e ? he(e) : null
}), Se = {
  name: "AddToSearchHistory",
  body: "mutation AddToSearchHistory($input: EmptyPrefixSuggestHistoryEntityInputInput!) { emptyPrefixSuggest { history { add { movie(input: $input) { error { message } status } } } } }",
  get variables() {
  },
  get query() {
  }
}, io = p(Se, {
  resolve: (e) => {
    var t, n, o;
    return (o = (n = (t = e == null ? void 0 : e.emptyPrefixSuggest) == null ? void 0 : t.history) == null ? void 0 : n.add) == null ? void 0 : o.movie;
  }
}), ye = {
  name: "AssignDcbSubscription",
  body: "mutation AssignDcbSubscription { subscription { dcb { assign { status needsPollingForFeatureActivation } } } }",
  get variables() {
  },
  get query() {
  }
}, ro = p(ye, {
  resolve: (e) => {
    var t, n;
    return (n = (t = e == null ? void 0 : e.subscription) == null ? void 0 : t.dcb) == null ? void 0 : n.assign;
  }
}), Ie = s((e) => ({
  categories: e.reduce((n, o) => (o !== null && n.push(
    {
      id: o.id,
      title: o.title,
      description: o.description
    }
  ), n), [])
})), be = {
  name: "ChannelCategoryList",
  body: "query ChannelCategoryList { tvChannelCategories { ...ChannelCategoryMeta } } fragment ChannelCategoryMeta on TvChannelCategory { id title description }",
  get variables() {
  },
  get query() {
  }
}, ao = p(be, {
  resolve: (e) => e == null ? void 0 : e.tvChannelCategories,
  hydrate: (e) => e ? Ie(e) : null
}), we = s(
  (e) => {
    var t;
    return {
      isPurchased: e.purchasabilityStatus === "PURCHASED",
      isWatchable: e.watchabilityStatus === "WATCHABLE",
      type: e.type,
      purchaseOptionCustomProperties: e.purchaseOptionCustomProperties,
      subscriptionBadge: (t = e.subscriptionBadge) != null && t.image ? g(e.subscriptionBadge.image) : null
    };
  }
), P = s((e) => ({
  value: e.age,
  toString() {
    switch (e.age) {
      case "age0":
        return "0+";
      case "age6":
        return "6+";
      case "age12":
        return "12+";
      case "age14":
        return "14+";
      case "age15":
        return "15+";
      case "age16":
        return "16+";
      case "age18":
        return "18+";
      case "age21":
        return "21+";
      case "g":
        return "G";
      case "pg":
        return "PG";
      case "pg13":
        return "PG13";
      case "pg15":
        return "PG15";
      default:
        return;
    }
  }
})), X = s(
  (e) => {
    const t = new Date(e.startTime).getTime(), n = new Date(e.endTime).getTime(), o = n - t;
    return {
      id: e.id,
      title: e.title ?? "",
      startTime: t,
      endTime: n,
      duration: o,
      typeName: e.typeName,
      image: e.image ? g(e.image) : null,
      ageRestriction: e.ageRestriction ? P({ age: e.ageRestriction }) : null,
      episodeTitle: e.episodeTitle ?? "",
      elapsed(i) {
        return i - t;
      },
      remaining(i) {
        return n - i;
      },
      startsIn(i) {
        return t - i;
      }
    };
  }
), $ = s(
  ({ tvChannel: e, tvPrograms: t }) => {
    var l, c, m;
    const n = e.viewOption ? we(e.viewOption) : null, o = ((l = e.gallery) == null ? void 0 : l.logos.main) ?? e.logo, i = o ? g(o) : null, r = (m = (c = e.gallery) == null ? void 0 : c.cover) != null && m.horizontal ? g(e.gallery.cover.horizontal) : null, a = (t ?? []).reduce((u, d) => (d !== null && u.push(X(d)), u), []);
    return {
      contentId: e.contentId,
      title: e.title,
      viewOption: n,
      programs: a,
      logo: i,
      horizontalCover: r,
      getCurrentProgram(u) {
        return a.find(
          (d) => d.startTime <= u && u < d.endTime
        ) ?? null;
      },
      getNextProgram(u) {
        return a.find((d) => d.startTime > u) ?? null;
      }
    };
  }
), Te = s((e) => {
  const t = (e.items ?? []).reduce((n, o) => (o && o.tvChannel !== null && n.push(
    $({
      tvChannel: o.tvChannel,
      tvPrograms: o.tvChannel.tvPrograms
    })
  ), n), []);
  return {
    limit: e.limit,
    offset: e.offset,
    total: e.total ?? 0,
    channels: t
  };
}), Pe = {
  name: "ChannelList",
  body: 'query ChannelList($categoryIds: [Long]!, $limit: Int!, $offset: Int!, $withPrograms: Boolean!) { tvChannels(filter: {categoryIds: $categoryIds}, limit: $limit, offset: $offset) { ...TvChannels } } fragment TvChannels on PagingList_TvChannelListItem { items { tvChannel { ...TvChannel tvPrograms(duration: "PT1H") @include(if: $withPrograms) { ...TvChannelProgram } } } limit offset total } fragment TvChannel on TvChannel { contentId viewOption { ...TvChannelViewOption } title gallery { logos { main { ...Image } } } } fragment TvChannelViewOption on ViewOption { ...ViewOptionBase subscriptionBadge { image { ...Image } } } fragment ViewOptionBase on ViewOption { type watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties } fragment Image on Image { avatarsUrl fallbackUrl } fragment TvChannelProgram on TvProgram { id title startTime endTime typeName }',
  get variables() {
  },
  get query() {
  }
}, so = p(Pe, {
  resolve: (e) => e == null ? void 0 : e.tvChannels,
  hydrate: (e) => e ? Te(e) : null
}), Me = {
  name: "Channel",
  body: "query Channel($contentId: String!) { content(contentId: $contentId) { ...TvChannel } } fragment TvChannel on TvChannel { contentId viewOption { ...TvChannelViewOption } title gallery { logos { main { ...Image } } } } fragment TvChannelViewOption on ViewOption { ...ViewOptionBase subscriptionBadge { image { ...Image } } } fragment ViewOptionBase on ViewOption { type watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties } fragment Image on Image { avatarsUrl fallbackUrl }",
  get variables() {
  },
  get query() {
  }
}, lo = p(Me, {
  resolve: (e) => e == null ? void 0 : e.content,
  hydrate: (e) => e && "title" in e ? $({ tvChannel: e }) : null
}), Ce = s(({ tvPrograms: e }) => ({
  programs: (e ?? []).reduce((t, n) => (n !== null && t.push(X(n)), t), [])
})), Oe = {
  name: "ChannelProgramInfo",
  body: 'query ChannelProgramInfo($contentId: String!) { content(contentId: $contentId) { ... on TvChannel { channelContentId: contentId tvPrograms(duration: "PT12H", durationInPast: "PT12H") { id title startTime endTime episodeTitle ageRestriction typeName image { ...Image } } } } } fragment Image on Image { avatarsUrl fallbackUrl }',
  get variables() {
  },
  get query() {
  }
}, co = p(Oe, {
  resolve: (e) => {
    const t = e == null ? void 0 : e.content;
    return t && "tvPrograms" in t ? { tvPrograms: t.tvPrograms } : null;
  },
  hydrate: (e) => e ? Ce(e) : null
}), Ae = s((e) => {
  var t;
  return {
    isPurchased: e.purchasabilityStatus === "PURCHASED",
    isWatchable: e.watchabilityStatus === "WATCHABLE",
    watchPeriod: e.watchPeriod,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    purchaseOptionCustomProperties: e.purchaseOptionCustomProperties,
    subscriptionBadge: (t = e.subscriptionBadge) != null && t.image ? g(e.subscriptionBadge.image) : null
  };
}), L = (e) => typeof e == "number" && !isNaN(e) ? e : 0, E = s(
  ({ type: e, data: t }) => {
    var m, u, d, v, h, S, w, T;
    const n = e === "episode" ? f(((m = t.tvSeries) == null ? void 0 : m.title) ?? t.title) : f(t.title), o = e === "episode" ? (u = t.tvSeries) == null ? void 0 : u.contentId : t.contentId;
    let i = 0, r = 0, a = null, l = null;
    if (e === "episode")
      i = ((d = t.ott) == null ? void 0 : d.duration) ?? 0, r = L((h = (v = t.ott) == null ? void 0 : v.timing) == null ? void 0 : h.current), a = t.cover, l = { seasonNumber: (S = t.season) == null ? void 0 : S.number, seriesNumber: t.number };
    else if (((T = (w = t.ott) == null ? void 0 : w.preview) == null ? void 0 : T.__typename) === "OttPreview_AbstractVideo") {
      const b = t.ott.preview;
      i = L(b.duration), b.timing && (r = L(b.timing.current)), a = t.gallery.covers.horizontal ?? null;
    }
    const c = a ? g(a) : null;
    return {
      type: e,
      contentId: t.contentId ?? "",
      movieId: o ?? null,
      title: n,
      duration: i,
      backgroundUrl: c,
      watchProgressPosition: r,
      viewOption: t.viewOption ? Ae(t.viewOption) : null,
      tvSeries: l
    };
  }
), _e = s(
  ({ data: e, showcaseId: t }) => {
    var i, r, a;
    const n = t ? `${e.id}/${t}` : e.id, o = ((r = (i = e.content) == null ? void 0 : i.items) == null ? void 0 : r.reduce((l, c) => {
      if (!c || !("entity" in c))
        return l;
      switch (c.entity.__typename) {
        case "Episode":
          l.push(E({ type: "episode", data: c.entity }));
          break;
        case "Film":
        case "Video":
          l.push(E({ type: "movie", data: c.entity }));
          break;
      }
      return l;
    }, [])) ?? [];
    return {
      id: e.id,
      showcaseId: t,
      key: n,
      title: e.title ?? "",
      sessionId: ((a = e.content) == null ? void 0 : a.sessionId) ?? "",
      items: o
    };
  }
), Re = {
  name: "ContinueWatching",
  body: "query ContinueWatching($id: String!, $showcaseId: String, $selectionOffset: Int, $selectionLimit: Int, $ignoreCache: Boolean) { selection(id: $id, showcaseId: $showcaseId, ignoreCache: $ignoreCache) { ...ContinueWatching } } fragment ContinueWatching on ContinueWatchingEmbeddedSelection { id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId items { ... on ContinueWatchingSelectionItem { entity { __typename ...WatchingMovie ...WatchingEpisode } } } } } fragment WatchingMovie on Movie { id contentId title { ...Title } ott { preview { __typename ... on OttPreview_AbstractVideo { duration timing { current maximum } } } } gallery { covers { horizontal { ...Image } } } viewOption { ...WatchingViewOption } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment WatchingViewOption on ViewOption { purchasabilityStatus purchaseOptionCustomProperties watchPeriod { timeToExpire watchPeriodStatus } watchabilityStatus subscriptionBadge { image { ...Image } } } fragment WatchingEpisode on Episode { contentId title { ...Title } number season { contentId number } cover { ...Image } ott { duration timing { current maximum } } viewOption { ...WatchingViewOption } tvSeries { contentId title { ...Title } viewOption { ...WatchingViewOption } } }",
  get variables() {
  },
  get query() {
  }
}, mo = p(Re, {
  resolve: (e, t, n) => ({
    data: e == null ? void 0 : e.selection,
    showcaseId: (n == null ? void 0 : n.showcaseId) ?? void 0
  }),
  hydrate: (e) => e.data ? _e(e) : null
}), K = s((e) => {
  var t;
  return {
    isPurchased: e.purchasabilityStatus === "PURCHASED",
    isPurchasable: e.purchasabilityStatus === "PURCHASABLE",
    isWatchable: e.watchabilityStatus === "WATCHABLE",
    purchaseOptionCustomProperties: e.purchaseOptionCustomProperties ?? {},
    disclaimer: (t = e.texts) == null ? void 0 : t.disclaimer
  };
}), j = s(
  (e) => {
    var t, n, o, i, r;
    return {
      isPlannedToWatch: e.isPlannedToWatch ?? !1,
      emotion: ((t = e.emotion) == null ? void 0 : t.value) ?? null,
      isNotInterested: ((o = (n = e.watchStatuses) == null ? void 0 : n.notInterested) == null ? void 0 : o.value) ?? !1,
      isWatched: ((r = (i = e.watchStatuses) == null ? void 0 : i.watched) == null ? void 0 : r.value) ?? !1
    };
  }
), Ee = s(
  (e) => {
    var n, o, i;
    const t = (n = e.mainTrailers) == null ? void 0 : n.items;
    return t && t.length > 0 ? {
      trailerContentId: ((o = t.find((r) => r == null ? void 0 : r.main)) == null ? void 0 : o.contentGroupUuid) ?? ((i = t[0]) == null ? void 0 : i.contentGroupUuid)
    } : { trailerContentId: void 0 };
  }
), $e = s((e) => {
  var t;
  return {
    id: e.id,
    contentId: e.contentId,
    userData: e.userData ? j(e.userData) : null,
    viewOption: e.viewOption ? K(e.viewOption) : null,
    mainTrailer: e.ott ? Ee(e.ott) : null,
    announce: (t = e.viewOption) != null && t.availabilityAnnounce ? W(e.viewOption.availabilityAnnounce) : null,
    typename: e.__typename
  };
}), Le = {
  name: "MovieCardContentActions",
  body: "query MovieCardContentActions($contentId: String!, $isAuth: Boolean!) { movieByContentUuid(contentUuid: $contentId) { ...MovieCardContentActions } } fragment MovieCardContentActions on Movie { id contentId userData @include(if: $isAuth) { ...ContentActionsUserData } viewOption { watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties texts { disclaimer } availabilityAnnounce { ...AvailabilityAnnounce } } ott { ...MainTrailer } __typename } fragment ContentActionsUserData on MovieUserData { isPlannedToWatch emotion { value } watchStatuses { notInterested { value } watched { value } } } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise } fragment MainTrailer on Ott { mainTrailers: trailers(limit: 2) { items { contentGroupUuid main } } }",
  get variables() {
  },
  get query() {
  }
}, uo = p(Le, {
  resolve: (e) => e == null ? void 0 : e.movieByContentUuid,
  hydrate: (e) => e ? $e(e) : null
}), D = s((e) => {
  const { start: t, end: n } = e.releaseYears[0] ?? {};
  return {
    start: t,
    end: n,
    toString() {
      return n && t !== n ? t ? `${t}-${n}` : null : t ? `${t}` : null;
    }
  };
}), N = s((e) => ({
  id: String(e.id),
  name: e.name,
  originalName: e.originalName,
  toString() {
    return e.name || e.originalName || "";
  }
})), We = s((e) => {
  var o, i;
  const t = (((o = e.actors) == null ? void 0 : o.items) ?? []).reduce((r, a) => ((a == null ? void 0 : a.person) !== null && (a == null ? void 0 : a.person) !== void 0 && r.push(N(a.person)), r), []), n = (((i = e.directors) == null ? void 0 : i.items) ?? []).reduce((r, a) => ((a == null ? void 0 : a.person) !== null && (a == null ? void 0 : a.person) !== void 0 && r.push(N(a.person)), r), []);
  return {
    actors: t,
    directors: n
  };
}), De = {
  video4k: "4K",
  dynamicRangeHdr10: "HDR",
  audioDolbyDigitalPlus51: "5.1"
}, Ue = s((e) => (e.features ?? []).reduce(
  (t, n) => {
    if (((n == null ? void 0 : n.group) === "VIDEO" || (n == null ? void 0 : n.group) === "AUDIO" || (n == null ? void 0 : n.group) === "DYNAMIC_RANGE") && n.alias) {
      const o = De[n.alias];
      o && t.qualityFeatures.push({ title: o, group: n.group });
    }
    return n != null && n.displayName && (n.group === "VOICE" && t.voiceFeatures.push(n.displayName), n.group === "SUBTITLES" && t.subtitlesFeatures.push(n.displayName)), t;
  },
  { qualityFeatures: [], voiceFeatures: [], subtitlesFeatures: [] }
)), Be = s(
  (e) => {
    var o, i;
    const t = (((o = e.availableMetadata) == null ? void 0 : o.audioMeta) ?? []).reduce(
      (r, a) => (a !== null && r.push({
        languageName: a.languageName,
        qualityName: a.qualityName,
        studio: a.studio,
        type: a.type,
        forAdult: a.forAdult
      }), r),
      []
    ), n = (((i = e.availableMetadata) == null ? void 0 : i.subtitleMeta) ?? []).reduce(
      (r, a) => (a !== null && r.push({
        languageName: a.languageName,
        studio: a.studio,
        type: a.type,
        forAdult: a.forAdult
      }), r),
      []
    );
    return {
      audioTracks: t,
      subtitleTracks: n
    };
  }
), ke = s((e) => {
  var o, i;
  const t = e.rightholderForCoverRecommendedTheme || "DARK", n = (i = (o = e.rightholderForCover) == null ? void 0 : o.find(
    (r) => r.theme === t
  )) == null ? void 0 : i.image;
  return {
    logo: n ? g(n) : null,
    theme: t
  };
}), Z = s((e) => ({
  value: e.value,
  isActive: e.isActive,
  count: e.count
})), Ne = s((e) => {
  var t, n, o;
  return {
    top10Position: (n = (t = e.ratingLists) == null ? void 0 : t.top10) == null ? void 0 : n.position,
    kpRating: (o = e.rating) != null && o.kinopoisk ? Z(e.rating.kinopoisk) : void 0
  };
}), Ve = s((e) => {
  var v, h, S, w, T, b, C, O, A, _, R;
  let t = 0, n = null, o = 0, i = null;
  (e.__typename === "Video" || e.__typename === "Film") && (n = e.productionYear ? String(e.productionYear) : null, ((v = e.ott) == null ? void 0 : v.__typename) === "Ott_AbstractVideo" && ((h = e.ott.preview) == null ? void 0 : h.__typename) === "OttPreview_AbstractVideo" && (t = Number(e.ott.preview.duration ?? 0))), (e.__typename === "MiniSeries" || e.__typename === "TvSeries" || e.__typename === "TvShow") && (o = ((S = e.seasonsAll) == null ? void 0 : S.total) ?? 0, i = D(e));
  const r = (T = (w = e.ott) == null ? void 0 : w.preview) != null && T.availableMetadata ? Be(e.ott.preview) : null, a = e.genres.filter((y) => !!y.name).map((y) => y.name), l = e.countries.filter((y) => !!y.name).map((y) => y.name), c = e.gallery.covers.horizontal ? g(e.gallery.covers.horizontal) : null, m = e.gallery.logos.horizontal ? g(e.gallery.logos.horizontal) : null, u = e.gallery.posters.vertical ? g(e.gallery.posters.vertical) : null, d = (A = (O = (C = (b = e.ott) == null ? void 0 : b.promos) == null ? void 0 : C.items) == null ? void 0 : O[0]) == null ? void 0 : A.contentGroupUuid;
  return {
    typename: e.__typename,
    contentId: e.contentId,
    id: e.id,
    title: f(e.title),
    filmDuration: t,
    seasonsNumber: o,
    releaseYears: i,
    productionYear: n,
    features: (R = (_ = e.ott) == null ? void 0 : _.preview) != null && R.features ? Ue(e.ott.preview) : null,
    shortDescription: String(e.shortDescription ?? ""),
    editorAnnotation: String(e.editorAnnotation ?? ""),
    description: e.ottSynopsis ?? "",
    audioTracks: (r == null ? void 0 : r.audioTracks) ?? [],
    subtitleTracks: (r == null ? void 0 : r.subtitleTracks) ?? [],
    filmingCrew: We(e),
    genres: a,
    countries: l,
    cover: c,
    horizontalLogo: m,
    verticalPoster: u,
    rightholderLogo: ke(e.gallery.logos),
    promoTrailerContentId: d,
    restriction: e.restriction ? P(e.restriction) : null,
    ratings: Ne(e)
  };
}), Fe = {
  name: "MovieCardQuery",
  body: "query MovieCardQuery($contentId: String!, $withRating: Boolean!) { movieByContentUuid(contentUuid: $contentId) { ...MovieCard } } fragment MovieCard on Movie { contentId id title { ...Title } shortDescription editorAnnotation gallery { covers { horizontal { ...Image } } logos { ...MovieRightHolderLogo horizontal { ...Image ...ImageSize } } posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } } } restriction { age } genres { name } countries { name } ... on VideoInterface { productionYear(override: OTT_WHEN_EXISTS) } ... on Series { ...ReleaseYears seasonsAll: seasons(limit: 0) { total } } ott { preview { ...MovieFeatures ... on OttPreview_AbstractVideo { duration } ...AvailableMetadata __typename } promos: trailers(limit: 1, onlyPromo: true) { items { contentGroupUuid } } __typename } ottSynopsis: synopsis(override: OTT_WHEN_EXISTS) ...FilmingCrew ...Ratings __typename } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment MovieRightHolderLogo on MovieLogos { rightholderForCover(filter: {formFactor: M}) { image { ...Image } theme } rightholderForCoverRecommendedTheme } fragment ImageSize on Image { origSize { width height } } fragment ReleaseYears on Series { releaseYears { start end } } fragment MovieFeatures on OttPreview { features(filter: {layout: OTT_TITLE_CARD, onlyClientSupported: true}) { alias displayName group } } fragment AvailableMetadata on OttPreview { availableMetadata { audioMeta { ...AudioMeta } subtitleMeta { ...SubtitleMeta } } } fragment AudioMeta on AudioMeta { __typename audioChannelsNumber audioGroupId forAdult language languageName quality qualityName studioName studio title visibleByDefault type } fragment SubtitleMeta on SubtitleMeta { __typename forAdult languageName studio type language title url visibleByDefault } fragment FilmingCrew on Movie { actors: members(limit: 10, role: [ACTOR, CAMEO, UNCREDITED]) { items { person { id name originalName } } } directors: members(role: DIRECTOR, limit: 5) { items { person { id name originalName } } } } fragment Ratings on Movie { ratingLists { top10 { position } } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment RatingValue on RatingValue { __typename value isActive count }",
  get variables() {
  },
  get query() {
  }
}, go = p(Fe, {
  resolve: (e) => e == null ? void 0 : e.movieByContentUuid,
  hydrate: (e) => e ? Ve(e) : null
}), ze = s((e) => {
  var t;
  return {
    isPurchasable: e.purchasabilityStatus === "PURCHASABLE",
    isWatchable: e.watchabilityStatus === "WATCHABLE",
    subscriptionBadge: (t = e.subscriptionBadge) != null && t.image ? g(e.subscriptionBadge.image) : null
  };
}), xe = s(
  (e) => ({
    isPlannedToWatch: e.isPlannedToWatch ?? !1
  })
), J = s(({ data: e, isSeasonAnnounce: t }) => ({
  availabilityDate: e.availabilityDate ? `${e.availabilityDate}Z` : "",
  announcePromise: e.announcePromise ?? "",
  isSeasonAnnounce: t
})), M = s(
  (e) => {
    var d, v, h, S;
    const t = f(e.title), n = e.viewOption ? ze(e.viewOption) : null;
    let o = null;
    (d = e.viewOption) != null && d.availabilityAnnounce && (o = J({
      data: e.viewOption.availabilityAnnounce,
      isSeasonAnnounce: !1
    }));
    const i = e.gallery.posters;
    let r = i.verticalWithRightholderLogo ?? i.vertical, a = i.horizontalWithRightholderLogo ?? i.horizontal;
    o && (r = i.verticalIntroWithRightholderLogo ?? i.verticalIntro, a = i.horizontalIntroWithRightholderLogo ?? i.horizontalIntro);
    const l = r ? g(r) : null, c = a ? g(a) : null, m = e.userData ? xe(e.userData) : null, u = (v = e.rating) != null && v.kinopoisk ? Z(e.rating.kinopoisk) : null;
    return {
      id: e.id,
      contentId: e.contentId ?? "",
      title: t,
      verticalPoster: l,
      horizontalPoster: c,
      top10: ((S = (h = e.ratingLists) == null ? void 0 : h.top10) == null ? void 0 : S.position) ?? 0,
      kpRating: u,
      viewOption: n,
      availabilityAnounce: o,
      userData: m
    };
  }
), He = s((e) => {
  var n;
  const t = ((n = e == null ? void 0 : e.items) == null ? void 0 : n.reduce((o, i) => (i != null && i.movie && o.push(M(i.movie)), o), [])) ?? [];
  return {
    offset: (e == null ? void 0 : e.offset) ?? 0,
    limit: (e == null ? void 0 : e.limit) ?? 0,
    total: (e == null ? void 0 : e.total) ?? 0,
    items: t
  };
}), Ye = s((e) => ({
  id: e.id,
  name: e.name ?? "",
  poster: e.poster ? g(e.poster) : null,
  filmography: He(e.filmographyRelations)
})), Qe = s((e) => {
  var n;
  return {
    items: ((n = e == null ? void 0 : e.items) == null ? void 0 : n.reduce((o, i) => (i != null && i.person && o.push(Ye(i.person)), o), [])) ?? []
  };
}), Ge = {
  name: "MovieDirectorsFilmography",
  body: 'query MovieDirectorsFilmography($contentId: String!, $offset: Int!, $limit: Int!, $withUserData: Boolean!, $withRating: Boolean!) { movieByContentUuid(contentUuid: $contentId) { members(role: [DIRECTOR], offset: 0, limit: 2) { items { person { id name poster { ...Image } filmographyRelations( isOnline: true offset: $offset limit: $limit roleSlugs: ["DIRECTOR"] ) { ...Filmography } } } } } } fragment Image on Image { avatarsUrl fallbackUrl } fragment Filmography on PagingList_FilmographyItem { offset limit total items { movie { ...SelectionMovie } } } fragment SelectionMovie on Movie { id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } verticalIntro { ...Image } verticalIntroWithRightholderLogo { ...Image } horizontal { ...Image } horizontalWithRightholderLogo { ...Image } horizontalIntro { ...Image } horizontalIntroWithRightholderLogo { ...Image } } } viewOption { ...SelectionViewOption availabilityAnnounce { ...SelectionAvailabilityAnnounce } } ratingLists { top10 { position } } userData @include(if: $withUserData) { ...SelectionUserData } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment Title on Title { localized original } fragment SelectionViewOption on ViewOption { purchasabilityStatus watchabilityStatus subscriptionBadge { image { ...Image } } } fragment SelectionAvailabilityAnnounce on AvailabilityAnnounce { availabilityDate announcePromise } fragment SelectionUserData on MovieUserData { isPlannedToWatch } fragment RatingValue on RatingValue { __typename value isActive count }',
  get variables() {
  },
  get query() {
  }
}, po = p(Ge, {
  resolve: (e) => {
    var t;
    return (t = e == null ? void 0 : e.movieByContentUuid) == null ? void 0 : t.members;
  },
  hydrate: (e) => e ? Qe(e) : null
}), Xe = s((e) => {
  var t;
  return {
    id: e.id,
    contentId: e.contentId,
    userData: e.userData ? j(e.userData) : null,
    viewOption: e.viewOption ? K(e.viewOption) : null,
    announce: (t = e.viewOption) != null && t.availabilityAnnounce ? W(e.viewOption.availabilityAnnounce) : null,
    typename: e.__typename
  };
}), Ke = {
  name: "MoviePromoContentActions",
  body: "query MoviePromoContentActions($contentId: String!, $isAuth: Boolean!) { movieByContentUuid(contentUuid: $contentId) { ...MoviePromoContentActions } } fragment MoviePromoContentActions on Movie { id contentId userData @include(if: $isAuth) { ...ContentActionsUserData } viewOption { watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties availabilityAnnounce { ...AvailabilityAnnounce } } __typename } fragment ContentActionsUserData on MovieUserData { isPlannedToWatch emotion { value } watchStatuses { notInterested { value } watched { value } } } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise }",
  get variables() {
  },
  get query() {
  }
}, vo = p(Ke, {
  resolve: (e) => e == null ? void 0 : e.movieByContentUuid,
  hydrate: (e) => e ? Xe(e) : null
}), je = s((e) => {
  var n;
  return {
    items: ((n = e == null ? void 0 : e.items) == null ? void 0 : n.reduce((o, i) => (i != null && i.movie && o.push(M(i.movie)), o), [])) ?? []
  };
}), Ze = {
  name: "MovieSimilar",
  body: "query MovieSimilar($contentId: String!, $offset: Int!, $limit: Int!, $withUserData: Boolean!, $withRating: Boolean!, $availability: SimilarMoviesAvailabilityFilter = AVAILABLE_ONLINE) { movieByContentUuid(contentUuid: $contentId) { similarMovies( filter: {availability: $availability} offset: $offset limit: $limit ) { items { movie { ...SelectionMovie } } } } } fragment SelectionMovie on Movie { id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } verticalIntro { ...Image } verticalIntroWithRightholderLogo { ...Image } horizontal { ...Image } horizontalWithRightholderLogo { ...Image } horizontalIntro { ...Image } horizontalIntroWithRightholderLogo { ...Image } } } viewOption { ...SelectionViewOption availabilityAnnounce { ...SelectionAvailabilityAnnounce } } ratingLists { top10 { position } } userData @include(if: $withUserData) { ...SelectionUserData } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SelectionViewOption on ViewOption { purchasabilityStatus watchabilityStatus subscriptionBadge { image { ...Image } } } fragment SelectionAvailabilityAnnounce on AvailabilityAnnounce { availabilityDate announcePromise } fragment SelectionUserData on MovieUserData { isPlannedToWatch } fragment RatingValue on RatingValue { __typename value isActive count }",
  get variables() {
  },
  get query() {
  }
}, ho = p(Ze, {
  resolve: (e) => {
    var t;
    return (t = e == null ? void 0 : e.movieByContentUuid) == null ? void 0 : t.similarMovies;
  },
  hydrate: (e) => e ? je(e) : null
}), Je = s(
  (e) => {
    var n, o, i;
    const t = (i = (o = (n = e.sparkMoviePageByContentId) == null ? void 0 : n.htmlMeta) == null ? void 0 : o.openGraph) == null ? void 0 : i.image;
    return {
      cover: t ? g(t) : null
    };
  }
), qe = {
  name: "MovieWebPage",
  body: "query MovieWebPage($contentId: String!) { webPage { sparkMoviePageByContentId(contentId: $contentId) { htmlMeta { openGraph { image { ...Image } } } } } } fragment Image on Image { avatarsUrl fallbackUrl }",
  get variables() {
  },
  get query() {
  }
}, fo = p(qe, {
  resolve: (e) => e == null ? void 0 : e.webPage,
  hydrate: (e) => e ? Je(e) : null
}), et = s((e) => ({
  id: e.id,
  name: e.name ?? ""
})), tt = {
  name: "PersonSeoMeta",
  body: "query PersonSeoMeta($id: Long!) { person(id: $id) { id name } }",
  get variables() {
  },
  get query() {
  }
}, So = p(tt, {
  resolve: (e) => e == null ? void 0 : e.person,
  hydrate: (e) => e ? et(e) : null
}), nt = s((e) => {
  var t, n, o;
  switch (e.__typename) {
    case "TvChannel":
    case "Clip":
    case "OttTrailer":
      return P({ age: e.ageRestriction ?? null });
    case "Episode":
      return P({ age: ((n = (t = e.tvSeries) == null ? void 0 : t.restriction) == null ? void 0 : n.age) ?? null });
    case "Film":
    case "Video":
      return P({ age: ((o = e.restriction) == null ? void 0 : o.age) ?? null });
    default:
      return P({ age: null });
  }
}), V = s(
  (e) => ({
    startTime: e.startTime,
    endTime: e.endTime,
    type: e.type ?? null,
    final: e.final
  })
), F = s(
  (e) => ({
    title: f(e.title),
    editorAnnotation: e.editorAnnotation ?? null,
    horizontalLogo: e.gallery.logos.horizontal ? g(e.gallery.logos.horizontal) : null
  })
), ot = s((e) => {
  var i, r;
  const t = (i = e == null ? void 0 : e.items) == null ? void 0 : i[0], n = (t == null ? void 0 : t.episodeContentId) ?? null, o = ((r = t == null ? void 0 : t.viewOption) == null ? void 0 : r.watchabilityStatus) === "WATCHABLE";
  return {
    nextEpisodeContentId: n && o ? n : null
  };
}), z = s(
  (e) => {
    var t, n;
    return {
      audioLanguage: ((t = e.watchParams) == null ? void 0 : t.audioLanguage) ?? null,
      subtitleLanguage: ((n = e.watchParams) == null ? void 0 : n.subtitleLanguage) ?? null
    };
  }
), it = s((e) => {
  var n, o, i, r, a, l, c, m;
  const t = nt(e);
  switch (e.__typename) {
    case "Film":
    case "Video": {
      const { filmOtt: u } = e, d = F(e);
      if ((u == null ? void 0 : u.__typename) === "Ott_AbstractVideo") {
        const v = (n = u.onlineStreams) == null ? void 0 : n.concurrencyArbiterConfig;
        return {
          typename: "Film",
          age: t,
          hasSmokingScenes: u.hasSmokingScenes ?? !1,
          skippableFragments: (u.skippableFragments ?? []).map(V),
          movieMeta: d,
          watchParams: (o = u.userData) != null && o.watchParams ? z(u.userData) : null,
          concurrencyArbiterConfig: v ? { server: v.server ?? null, concurrencyArbiterRequestParams: v.concurrencyArbiterRequestParams } : null
        };
      }
      return { typename: "Film", age: t, hasSmokingScenes: !1, skippableFragments: [], movieMeta: d, concurrencyArbiterConfig: null, watchParams: null };
    }
    case "Episode": {
      const u = (i = e.tvSeries) == null ? void 0 : i.ott, d = ot(e.neighbourhoodInSeries).nextEpisodeContentId, v = e.episodeOtt, h = (v == null ? void 0 : v.__typename) === "OttEpisode" ? (r = v.onlineStreams) == null ? void 0 : r.concurrencyArbiterConfig : null;
      return {
        typename: "Episode",
        age: t,
        hasSmokingScenes: (v == null ? void 0 : v.hasSmokingScenes) ?? !1,
        skippableFragments: ((v == null ? void 0 : v.skippableFragments) ?? []).map(V),
        tvSeriesContentId: ((a = e.tvSeries) == null ? void 0 : a.contentId) ?? null,
        nextEpisodeContentId: d,
        episodeNumber: e.number,
        episodeTitle: f(e.title),
        seasonNumber: ((l = e.season) == null ? void 0 : l.number) ?? null,
        seasonContentId: ((c = e.season) == null ? void 0 : c.contentId) ?? null,
        tvSeriesMeta: e.tvSeries ? F(e.tvSeries) : null,
        watchParams: (m = u == null ? void 0 : u.userData) != null && m.watchParams ? z(u.userData) : null,
        concurrencyArbiterConfig: h ? { server: h.server ?? null, concurrencyArbiterRequestParams: h.concurrencyArbiterRequestParams } : null
      };
    }
    default:
      return { typename: e.__typename, age: t };
  }
}), rt = {
  name: "PlayerMeta",
  body: "query PlayerMeta($contentId: String!) { content(contentId: $contentId) { ...ContentAgeRestriction ... on VideoInterface { ...PlayerMovieMeta filmOtt: ott { __typename ... on Ott_AbstractVideo { userData { ...MovieWatchParams } hasSmokingScenes skippableFragments { ...PlayerSkippableFragment } onlineStreams { concurrencyArbiterConfig { server concurrencyArbiterRequestParams } } } } } ... on Episode { number title { ...Title } season { contentId number } tvSeries { contentId ...PlayerMovieMeta ott { __typename userData { ...MovieWatchParams } } } neighbourhoodInSeries(limit: 1, filter: {source: ONLINE_WITH_ANNOUNCEMENTS}) { items { episodeContentId: contentId viewOption { watchabilityStatus } } } episodeOtt: ott { __typename hasSmokingScenes skippableFragments { ...PlayerSkippableFragment } ... on OttEpisode { onlineStreams { concurrencyArbiterConfig { server concurrencyArbiterRequestParams } } } } } } } fragment ContentAgeRestriction on Content { __typename ... on VideoInterface { restriction { age } } ... on Episode { tvSeries { contentId restriction { age } } } ... on TvChannel { ageRestriction } ... on Clip { ageRestriction } ... on OttTrailer { ageRestriction } } fragment PlayerMovieMeta on Movie { title { ...Title } editorAnnotation gallery { logos { horizontal { ...Image ...ImageSize } } } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment ImageSize on Image { origSize { width height } } fragment MovieWatchParams on OttUserData { watchParams { audioLanguage subtitleLanguage } } fragment PlayerSkippableFragment on SkippableFragment { startTime endTime final type }",
  get variables() {
  },
  get query() {
  }
}, yo = p(rt, {
  resolve: (e) => e == null ? void 0 : e.content,
  hydrate: (e) => e ? it(e) : null
});
function at(e) {
  return e == null ? null : e.reduce((t, n) => (n == null || t.push({
    highRes: n.highResolutionTiles,
    lowRes: n.lowResolutionTiles,
    offset: n.offset
  }), t), []);
}
function st(e, t) {
  const n = [...t].sort((o, i) => (i.offset ?? 0) - (o.offset ?? 0)).find((o) => e >= (o.offset ?? 0) / 1e3) ?? null;
  return {
    modifiedTime: e - ((n == null ? void 0 : n.offset) ?? 0) / 1e3,
    tile: n
  };
}
function x(e, t) {
  const { rows: n, columns: o } = e.spriteMatrixSize, { width: i, height: r } = e.tilePixelResolution, a = t ? 0.5 : 1, l = i * a, c = r * a;
  return {
    tileDuration: e.tileDuration,
    tilesInSprite: n * o,
    columns: o,
    uriTemplate: e.uriTemplate,
    tileWidth: l,
    tileHeight: c,
    spriteWidth: l * o,
    spriteHeight: c * n
  };
}
function H(e, t) {
  const { tileDuration: n, tilesInSprite: o, columns: i, uriTemplate: r, tileWidth: a, tileHeight: l, spriteWidth: c, spriteHeight: m } = t, u = Math.floor(e / n), d = u % o;
  return {
    spriteUrl: r.replace("$Number$", String(Math.floor(u / o))),
    offsetX: d % i * a,
    offsetY: Math.floor(d / i) * l,
    spriteWidth: c,
    spriteHeight: m,
    tileWidth: a,
    tileHeight: l
  };
}
function lt(e) {
  const t = at(e);
  return t == null ? null : {
    tiles: t,
    getPreviewFrame(n) {
      const { modifiedTime: o, tile: i } = st(n, t);
      return i == null ? null : {
        highRes: H(o, x(i.highRes, !0)),
        lowRes: H(o, x(i.lowRes, !1))
      };
    }
  };
}
function Y(e) {
  var n, o;
  const t = (n = e == null ? void 0 : e.streams) == null ? void 0 : n[0];
  return lt(((o = t == null ? void 0 : t.streamMeta) == null ? void 0 : o.tilesContainer) ?? null);
}
const ct = s(
  (e) => {
    var t;
    switch (e.__typename) {
      case "Film": {
        const { filmOtt: n } = e;
        return (n == null ? void 0 : n.__typename) === "Ott_AbstractVideo" ? {
          preview: Y(n.onlineStreams)
        } : { preview: null };
      }
      case "Episode":
        return {
          preview: Y(((t = e.episodeOtt) == null ? void 0 : t.onlineStreams) ?? null)
        };
      default:
        return { preview: null };
    }
  }
), mt = {
  name: "PlayerStreamMeta",
  body: "query PlayerStreamMeta($contentId: String!, $prerollsSupported: Boolean!) { content(contentId: $contentId) { __typename ... on Film { filmOtt: ott { __typename ... on Ott_AbstractVideo { onlineStreams(prerollsSupported: $prerollsSupported) { ...PlayerStreamMeta } } } } ... on Episode { episodeOtt: ott { __typename onlineStreams(prerollsSupported: $prerollsSupported) { ...PlayerStreamMeta } } } } } fragment PlayerStreamMeta on OnlineStreams { streams { streamMeta { tilesContainer { highResolutionTiles { ...Tile } lowResolutionTiles { ...Tile } offset } } } } fragment Tile on Tile { __typename spriteDuration tileDuration uriTemplate tilePixelResolution { ...PixelResolution } spriteMatrixSize { ...SpriteMatrixSize } spritePixelResolution { ...PixelResolution } } fragment PixelResolution on PixelResolution { __typename height width } fragment SpriteMatrixSize on SpriteMatrixSize { __typename columns rows }",
  get variables() {
  },
  get query() {
  }
}, Io = p(mt, {
  resolve: (e) => e == null ? void 0 : e.content,
  hydrate: (e) => e ? ct(e) : null
}), ut = s((e) => e), gt = s((e) => e), pt = s((e) => e), dt = s((e) => e), vt = s((e) => e), ht = s((e) => e), ft = s((e) => e);
function St(e) {
  switch (e.__typename) {
    case "Film":
      return dt(e);
    case "Video":
      return vt(e);
    case "Episode":
      return pt(e);
    case "TvChannel":
      return ut(e);
    case "Clip":
      return gt(e);
    case "OttTrailer":
      return ft(e);
    case "SportBroadcast":
      return ht(e);
    default:
      return null;
  }
}
const yt = {
  name: "PlayerBaseInfo",
  body: 'query PlayerBaseInfo($contentId: String!, $prerollsSupported: Boolean = false) { content(contentId: $contentId) { __typename ... on VideoInterface { ...LegacyFilmPlayerBaseInfo } ... on Episode { ...LegacyEpisodePlayerBaseInfo } ... on TvChannel { ...LegacyChannelPlayerBaseInfo } ... on Clip { ...LegacyClipPlayerBaseInfo } ... on OttTrailer { ...LegacyTrailerPlayerBaseInfo } ... on SportBroadcast { ...LegacySportBroadcastPlayerBaseInfo } } } fragment LegacyFilmPlayerBaseInfo on VideoInterface { filmContentId: contentId id filmTitle: title { ...Title } filmOtt: ott { __typename ... on Ott_AbstractVideo { onlineStreams(prerollsSupported: $prerollsSupported) { ...MovieOnlineStreams } hasSmokingScenes } preview { __typename ... on OttPreview_AbstractVideo { timing { current } duration } } userData { watchParams { audioLanguage subtitleLanguage } } } restriction { age } } fragment Title on Title { localized original } fragment MovieOnlineStreams on OnlineStreams { licenseStatus drmRequirement streams { ...MovieStream } sessionId concurrencyArbiterConfig { concurrencyArbiterRequestParams server } playerRestrictionConfig { subtitlesButtonEnable } monetizationModel } fragment MovieStream on Stream { streamMeta { ...MovieStreamMeta } uri } fragment MovieStreamMeta on StreamMeta { audioMetas { ...MovieStreamAudioMeta } drmConfig { ...MovieStreamDrmConfig } subtitleMetas { ...MovieStreamSubtitleMeta } tilesContainer { ...MovieStreamTiles } trackings videoMetas { bitrate height width } prerollsDuration prerolls { ...MovieStreamPrerolls } skippableFragments { ...MovieStreamSkippableFragment } videoToken cuesUrl } fragment MovieStreamAudioMeta on AudioMeta { audioChannelsNumber audioGroupId forAdult language languageName quality studioName title visibleByDefault } fragment MovieStreamDrmConfig on DrmConfig { drmServers { certificateUrl name processSPCPath provisioningUrl url } headers requestParams } fragment MovieStreamSubtitleMeta on SubtitleMeta { forAdult languageName studio type language title url visibleByDefault } fragment MovieStreamTiles on TilesContainer { highResolutionTiles { ...MovieStreamTile } lowResolutionTiles { ...MovieStreamTile } offset } fragment MovieStreamTile on Tile { spriteDuration tileDuration uriTemplate tilePixelResolution { height width } spriteMatrixSize { columns rows } spritePixelResolution { height width } } fragment MovieStreamPrerolls on PrerollMeta { durationMs promotedEntityId } fragment MovieStreamSkippableFragment on SkippableFragment { startTime endTime final type } fragment LegacyEpisodePlayerBaseInfo on Episode { id contentId number episodeContentId: contentId episodeTitle: title { ...Title } season { id contentId number } viewOption { watchabilityStatus } episodeOtt: ott { __typename ... on OttEpisode { hasSmokingScenes onlineStreams(prerollsSupported: $prerollsSupported) { ...MovieOnlineStreams } } timing { current } duration } neighbourhoodInSeries(limit: 1, filter: {source: ONLINE_WITH_ANNOUNCEMENTS}) { items { ... on Episode { ...EpisodeDetailsFragment } } } tvSeries { restriction { age } contentId id ott { userData { watchParams { audioLanguage subtitleLanguage } } } } } fragment EpisodeDetailsFragment on Episode { id contentId number episodeContentId: contentId tvSeries { contentId id } viewOption { watchabilityStatus } season { id contentId number } } fragment LegacyChannelPlayerBaseInfo on TvChannel { channelContentId: contentId ageRestriction title gallery { logos { main { avatarsUrl fallbackUrl } } covers { horizontal { avatarsUrl fallbackUrl } } } isNeedToHidePrograms isMultiplex ...ChannelStreams ...ChannelPrograms } fragment ChannelStreams on TvChannel { onlineStreams { ...MovieOnlineStreams } } fragment ChannelPrograms on TvChannel { programs: tvPrograms(duration: "PT4H") { ...ChannelProgram } } fragment ChannelProgram on TvProgram { id title startTime endTime episodeTitle ageRestriction typeName image { avatarsUrl fallbackUrl } } fragment LegacyClipPlayerBaseInfo on Clip { clipContentId: contentId ...ClipStreams } fragment ClipStreams on Clip { onlineStreams { ...ClipOnlineStreams } } fragment ClipOnlineStreams on OnlineStreams { licenseStatus drmRequirement streams { ...ClipStream } sessionId concurrencyArbiterConfig { concurrencyArbiterRequestParams server } playerRestrictionConfig { subtitlesButtonEnable } monetizationModel } fragment ClipStream on Stream { streamMeta { ...ClipStreamMeta } uri } fragment ClipStreamMeta on StreamMeta { audioMetas { ...MovieStreamAudioMeta } drmConfig { ...MovieStreamDrmConfig } subtitleMetas { ...MovieStreamSubtitleMeta } tilesContainer { ...MovieStreamTiles } trackings videoMetas { bitrate height width } skippableFragments { ...MovieStreamSkippableFragment } videoToken cuesUrl } fragment LegacyTrailerPlayerBaseInfo on OttTrailer { contentGroupUuid ageRestriction streams { ...TrailerStream } } fragment TrailerStream on Stream { uri streamType streamMeta { ...TrailerStreamMeta } __typename } fragment TrailerStreamMeta on StreamMeta { __typename audioMetas { ...AudioMeta } videoMetas { ...VideoMeta } subtitleMetas { ...SubtitleMeta } drmConfig { ...DrmConfig } trackings } fragment AudioMeta on AudioMeta { __typename audioChannelsNumber audioGroupId forAdult language languageName quality qualityName studioName studio title visibleByDefault type } fragment VideoMeta on VideoMeta { __typename ...BaseVideoMeta dynamicRange codec label } fragment BaseVideoMeta on VideoMeta { __typename bitrate height width lastFrameImage { ...PlayerImage } } fragment PlayerImage on Image { __typename avatarsUrl fallbackUrl origSize { ...PlayerImageSize } } fragment PlayerImageSize on ImageSize { __typename width height } fragment SubtitleMeta on SubtitleMeta { __typename forAdult languageName studio type language title url visibleByDefault } fragment DrmConfig on DrmConfig { __typename drmServers { ...DrmServers } headers requestParams } fragment DrmServers on DrmServer { __typename certificateUrl name processSPCPath provisioningUrl url } fragment LegacySportBroadcastPlayerBaseInfo on SportBroadcast { __typename sportBroadcastContentId: contentId onlineStreams { ...MovieOnlineStreams } }',
  get variables() {
  },
  get query() {
  }
}, bo = p(yt, {
  resolve: (e) => e == null ? void 0 : e.content,
  hydrate: (e) => e ? St(e) : null
}), It = s((e) => ({
  createdAt: (e == null ? void 0 : e.createdAt) ?? "",
  id: (e == null ? void 0 : e.id) ?? "",
  timeToExpire: (e == null ? void 0 : e.watchPeriod.timeToExpire) ?? 0,
  watchPeriodStatus: (e == null ? void 0 : e.watchPeriod.watchPeriodStatus) ?? null
})), bt = s(
  (e) => {
    if (!e.purchasedContent)
      throw new Error("Invalid purchase data");
    return {
      metadata: It(e.purchaseMetadata),
      movie: M(e.purchasedContent)
    };
  }
), wt = s((e) => ({
  hasMore: e.hasMore,
  nextCursor: e.nextCursor ?? "",
  purchases: e.items.reduce((t, n) => (n.purchasedContent && t.push(bt(n)), t), [])
})), Tt = {
  name: "Purchases",
  body: "query Purchases($cursor: String, $limit: Int, $withUserData: Boolean!, $withRating: Boolean!) { userProfile { purchases(cursor: $cursor, limit: $limit) { ...PurchasesList } } } fragment PurchasesList on CursorPagingList_PurchaseListItem_String { hasMore nextCursor items { ...Purchase } } fragment Purchase on PurchaseListItem { purchaseMetadata { ...PurchaseMetadataItem } purchasedContent { ...SelectionMovie } } fragment PurchaseMetadataItem on PurchaseMetadata { createdAt id watchPeriod { timeToExpire watchPeriodStatus } } fragment SelectionMovie on Movie { id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } verticalIntro { ...Image } verticalIntroWithRightholderLogo { ...Image } horizontal { ...Image } horizontalWithRightholderLogo { ...Image } horizontalIntro { ...Image } horizontalIntroWithRightholderLogo { ...Image } } } viewOption { ...SelectionViewOption availabilityAnnounce { ...SelectionAvailabilityAnnounce } } ratingLists { top10 { position } } userData @include(if: $withUserData) { ...SelectionUserData } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SelectionViewOption on ViewOption { purchasabilityStatus watchabilityStatus subscriptionBadge { image { ...Image } } } fragment SelectionAvailabilityAnnounce on AvailabilityAnnounce { availabilityDate announcePromise } fragment SelectionUserData on MovieUserData { isPlannedToWatch } fragment RatingValue on RatingValue { __typename value isActive count }",
  get variables() {
  },
  get query() {
  }
}, wo = p(Tt, {
  resolve: (e) => {
    var t;
    return (t = e == null ? void 0 : e.userProfile) == null ? void 0 : t.purchases;
  },
  hydrate: (e) => e ? wt(e) : null
}), Pt = {
  name: "RemoveContinueWatchingItem",
  body: "mutation RemoveContinueWatchingItem($contentId: String!) { continueWatching { remove(input: {contentId: $contentId}) { status error { message } } } }",
  get variables() {
  },
  get query() {
  }
}, To = p(
  Pt,
  {
    resolve: (e) => {
      var t;
      return (t = e == null ? void 0 : e.continueWatching) == null ? void 0 : t.remove;
    }
  }
), Mt = {
  name: "RemoveFromSearchHistory",
  body: "mutation RemoveFromSearchHistory($input: EmptyPrefixSuggestHistoryEntityInputInput!) { emptyPrefixSuggest { history { remove { movie(input: $input) { error { message } status } } } } }",
  get variables() {
  },
  get query() {
  }
}, Po = p(Mt, {
  resolve: (e) => {
    var t, n, o;
    return (o = (n = (t = e == null ? void 0 : e.emptyPrefixSuggest) == null ? void 0 : t.history) == null ? void 0 : n.remove) == null ? void 0 : o.movie;
  }
}), Ct = {
  name: "RemovePlannedToWatch",
  body: "mutation RemovePlannedToWatch($movieId: Long!) { movie { plannedToWatch { remove(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, Mo = p(Ct, {
  resolve: (e) => {
    var t, n;
    return (n = (t = e == null ? void 0 : e.movie) == null ? void 0 : t.plannedToWatch) == null ? void 0 : n.remove;
  }
}), Ot = (e) => {
  var t;
  return {
    number: e.number,
    contentId: e.contentId,
    episodesCount: ((t = e.episodes) == null ? void 0 : t.total) ?? 0
  };
}, At = s((e) => {
  var n, o, i;
  const t = ("seasons" in e ? ((n = e.seasons) == null ? void 0 : n.items) ?? [] : []).reduce((r, a) => (a && a.contentId !== null && r.push(Ot(a)), r), []);
  return {
    contentId: e.contentId,
    isPurchasable: ((o = e.viewOption) == null ? void 0 : o.purchasabilityStatus) === "PURCHASABLE",
    isPurchased: ((i = e.viewOption) == null ? void 0 : i.purchasabilityStatus) === "PURCHASED",
    items: t
  };
}), _t = {
  name: "SeasonsMetadata",
  body: "query SeasonsMetadata($contentId: String!, $limit: Int = 10000, $offset: Int = 0, $source: Source = ONLINE_WITH_ANNOUNCEMENTS) { movieByContentUuid(contentUuid: $contentId) { contentId ... on Series { seasons(offset: $offset, limit: $limit, source: $source) { items { number contentId episodes(limit: 1, source: $source) { total } } } } viewOption { purchasabilityStatus } } }",
  get variables() {
  },
  get query() {
  }
}, Co = p(_t, {
  resolve: (e) => e == null ? void 0 : e.movieByContentUuid,
  hydrate: (e) => e ? At(e) : null
}), Rt = s((e) => {
  var t, n;
  return {
    isWatchable: e.watchabilityStatus === "WATCHABLE",
    isPurchased: e.purchasabilityStatus === "PURCHASED",
    subscriptionBadge: (t = e.subscriptionBadge) != null && t.image ? g(e.subscriptionBadge.image) : null,
    billingFeatureName: ((n = e.contentPackageToBuy) == null ? void 0 : n.billingFeatureName) ?? null
  };
}), Et = s((e) => ({
  id: e.id,
  contentId: e.contentId ?? null,
  number: e.number
})), $t = s((e) => {
  var i, r, a, l, c, m, u, d, v;
  const t = ((r = (i = e.ott) == null ? void 0 : i.viewOption) == null ? void 0 : r.availabilityStatus) ?? null, n = e.viewOption ? Rt(e.viewOption) : null, o = e.season ? Et(e.season) : null;
  return {
    id: String(e.id),
    contentId: e.contentId ?? null,
    number: e.number,
    title: f(e.title),
    synopsis: e.synopsis ?? null,
    cover: e.cover ? g(e.cover) : null,
    season: o,
    duration: ((a = e.ott) == null ? void 0 : a.duration) ?? 0,
    watchProgressPosition: ((c = (l = e.ott) == null ? void 0 : l.timing) == null ? void 0 : c.current) ?? null,
    editorAnnotation: ((m = e.ott) == null ? void 0 : m.editorAnnotation) ?? null,
    plannedAvailabilityDate: ((u = e.ott) == null ? void 0 : u.plannedAvailabilityDate) ?? null,
    availabilityStatus: t,
    availabilityEndDate: ((v = (d = e.ott) == null ? void 0 : d.viewOption) == null ? void 0 : v.availabilityEndDate) ?? null,
    isDisabled: t === "DISABLED",
    isPublished: t === "PUBLISHED",
    viewOption: n
  };
}), Lt = s((e) => {
  var o, i, r;
  const t = ((o = e.episodes) == null ? void 0 : o.items) ?? [], n = {
    total: ((i = e.episodes) == null ? void 0 : i.total) ?? 0,
    items: t.filter((a) => a !== null).map($t)
  };
  return {
    id: e.id,
    contentId: e.contentId ?? null,
    number: e.number,
    purchaseOptionCustomProperties: ((r = e.viewOption) == null ? void 0 : r.purchaseOptionCustomProperties) ?? null,
    episodes: n
  };
}), Wt = {
  name: "SeasonWithEpisodes",
  body: "query SeasonWithEpisodes($contentId: String!, $limit: Int!, $offset: Int!, $withUserData: Boolean!, $source: Source = ONLINE_WITH_ANNOUNCEMENTS) { seasonByContentId(contentId: $contentId) { id contentId number viewOption { purchaseOptionCustomProperties } episodes(limit: $limit, offset: $offset, source: $source) { total items { ...Episode } } } } fragment Episode on Episode { id contentId number synopsis(override: OTT_WHEN_EXISTS) title { ...Title } season { ...Season } cover { ...Image } ott { duration editorAnnotation plannedAvailabilityDate viewOption { availabilityStatus availabilityEndDate } timing @include(if: $withUserData) { current } } viewOption { ...EpisodeViewOption } } fragment Title on Title { localized original } fragment Season on Season { id contentId number } fragment Image on Image { avatarsUrl fallbackUrl } fragment EpisodeViewOption on ViewOption { purchasabilityStatus watchabilityStatus contentPackageToBuy { billingFeatureName } subscriptionBadge { image { ...Image } } }",
  get variables() {
  },
  get query() {
  }
}, Oo = p(Wt, {
  resolve: (e) => e == null ? void 0 : e.seasonByContentId,
  hydrate: (e) => e ? Lt(e) : null
}), Dt = s(
  (e) => {
    var r, a;
    if (!("movie" in e) || !e.movie)
      throw new Error("Invalid data");
    const t = M(e.movie);
    let { verticalPoster: n, horizontalPoster: o, availabilityAnounce: i } = t;
    if ("season" in e && ((a = (r = e.season) == null ? void 0 : r.viewOption) != null && a.availabilityAnnounce)) {
      i = J({
        data: e.season.viewOption.availabilityAnnounce,
        isSeasonAnnounce: !0
      });
      const l = e.movie.gallery.posters, c = l.verticalIntroWithRightholderLogo ?? l.verticalIntro, m = l.horizontalIntroWithRightholderLogo ?? l.horizontalIntro;
      n = c ? g(c) : null, o = m ? g(m) : null;
    }
    return {
      ...t,
      availabilityAnounce: i,
      verticalPoster: n,
      horizontalPoster: o
    };
  }
), U = s(({ data: e, showcaseId: t }) => {
  var o, i, r, a, l;
  const n = t ? `${e.id}/${t}` : e.id;
  return {
    typename: e.__typename,
    type: "default",
    id: e.id,
    showcaseId: t,
    key: n,
    title: e.title ?? "",
    comment: e.comment ?? "",
    offset: ((o = e.content) == null ? void 0 : o.offset) ?? 0,
    hasMore: ((i = e.content) == null ? void 0 : i.hasMore) ?? !1,
    sessionId: ((r = e.content) == null ? void 0 : r.sessionId) ?? "",
    items: ((l = (a = e.content) == null ? void 0 : a.items) == null ? void 0 : l.reduce((c, m) => (m && "movie" in m && m.movie && c.push(Dt(m)), c), [])) ?? []
  };
}), Ut = {
  name: "Selection",
  body: "query Selection($id: String!, $showcaseId: String, $selectionOffset: Int, $selectionLimit: Int, $withUserData: Boolean!, $withRating: Boolean!) { selection(id: $id, showcaseId: $showcaseId) { ...DefaultSelection } } fragment DefaultSelection on AbstractSelection { __typename id title comment content(offset: $selectionOffset, limit: $selectionLimit) { offset hasMore sessionId items { ...SelectionEntity } } } fragment SelectionEntity on SelectionItem { __typename ... on AbstractMovieSelectionItem { movie { ...SelectionMovie } ... on SeasonAnnounceSelectionItem { season { viewOption { availabilityAnnounce { ...SelectionAvailabilityAnnounce } } } } } } fragment SelectionMovie on Movie { id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } verticalIntro { ...Image } verticalIntroWithRightholderLogo { ...Image } horizontal { ...Image } horizontalWithRightholderLogo { ...Image } horizontalIntro { ...Image } horizontalIntroWithRightholderLogo { ...Image } } } viewOption { ...SelectionViewOption availabilityAnnounce { ...SelectionAvailabilityAnnounce } } ratingLists { top10 { position } } userData @include(if: $withUserData) { ...SelectionUserData } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SelectionViewOption on ViewOption { purchasabilityStatus watchabilityStatus subscriptionBadge { image { ...Image } } } fragment SelectionAvailabilityAnnounce on AvailabilityAnnounce { availabilityDate announcePromise } fragment SelectionUserData on MovieUserData { isPlannedToWatch } fragment RatingValue on RatingValue { __typename value isActive count }",
  get variables() {
  },
  get query() {
  }
}, Ao = p(Ut, {
  resolve: (e, t, n) => ({
    data: e == null ? void 0 : e.selection,
    showcaseId: (n == null ? void 0 : n.showcaseId) ?? void 0
  }),
  hydrate: (e) => e.data ? U(e) : null
}), Bt = {
  name: "RemoveMovieEmotion",
  body: "mutation RemoveMovieEmotion($movieId: Long!, $value: EmotionValue!) { movie { emotion { remove(input: {movieId: $movieId, value: $value}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, kt = {
  name: "SetMovieEmotion",
  body: "mutation SetMovieEmotion($movieId: Long!, $value: EmotionValue!) { movie { emotion { set(input: {movieId: $movieId, value: $value}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, q = s((e) => e), _o = p(Bt, {
  resolve: (e) => {
    var o, i, r;
    const t = (i = (o = e == null ? void 0 : e.movie) == null ? void 0 : o.emotion) == null ? void 0 : i.remove;
    if ((t == null ? void 0 : t.status) === "FAIL")
      throw new I(((r = t.error) == null ? void 0 : r.message) ?? "Failed to remove movie emotion");
    return {
      emotion: void 0
    };
  },
  hydrate: q
}), Ro = p(kt, {
  resolve: (e, t, n) => {
    var i, r, a;
    const o = (r = (i = e == null ? void 0 : e.movie) == null ? void 0 : i.emotion) == null ? void 0 : r.set;
    if ((o == null ? void 0 : o.status) === "FAIL")
      throw new I(((a = o.error) == null ? void 0 : a.message) ?? "Failed to set movie emotion");
    return {
      emotion: n == null ? void 0 : n.value
    };
  },
  hydrate: q
}), Nt = {
  name: "RemoveMovieNotInterested",
  body: "mutation RemoveMovieNotInterested($movieId: Long!) { movie { notInterested { remove(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, Vt = {
  name: "SetMovieNotInterested",
  body: "mutation SetMovieNotInterested($movieId: Long!) { movie { notInterested { set(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, ee = s(
  (e) => e
), Eo = p(
  Nt,
  {
    resolve: (e) => {
      var n, o, i;
      const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.notInterested) == null ? void 0 : o.remove;
      if ((t == null ? void 0 : t.status) === "FAIL")
        throw new I(
          ((i = t.error) == null ? void 0 : i.message) ?? "Failed to remove movie not interested"
        );
      return {
        notInterested: !1
      };
    },
    hydrate: ee
  }
), $o = p(Vt, {
  resolve: (e) => {
    var n, o, i;
    const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.notInterested) == null ? void 0 : o.set;
    if ((t == null ? void 0 : t.status) === "FAIL")
      throw new I(((i = t.error) == null ? void 0 : i.message) ?? "Failed to set movie not interested");
    return {
      notInterested: !0
    };
  },
  hydrate: ee
}), Ft = {
  name: "RemoveMoviePlannedToWatch",
  body: "mutation RemoveMoviePlannedToWatch($movieId: Long!) { movie { plannedToWatch { remove(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, zt = {
  name: "SetMoviePlannedToWatch",
  body: "mutation SetMoviePlannedToWatch($movieId: Long!) { movie { plannedToWatch { set(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, te = s(
  (e) => e
), Lo = p(
  Ft,
  {
    resolve: (e) => {
      var n, o, i;
      const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.plannedToWatch) == null ? void 0 : o.remove;
      if ((t == null ? void 0 : t.status) === "FAIL")
        throw new I(
          ((i = t.error) == null ? void 0 : i.message) ?? "Failed to remove movie planned to watch"
        );
      return {
        plannedToWatch: !1
      };
    },
    hydrate: te
  }
), Wo = p(zt, {
  resolve: (e) => {
    var n, o, i;
    const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.plannedToWatch) == null ? void 0 : o.set;
    if ((t == null ? void 0 : t.status) === "FAIL")
      throw new I(
        ((i = t.error) == null ? void 0 : i.message) ?? "Failed to set movie planned to watch"
      );
    return {
      plannedToWatch: !0
    };
  },
  hydrate: te
}), xt = {
  name: "RemoveMovieWatched",
  body: "mutation RemoveMovieWatched($movieId: Long!) { movie { watched { remove(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, Ht = {
  name: "SetMovieWatched",
  body: "mutation SetMovieWatched($movieId: Long!) { movie { watched { set(input: {movieId: $movieId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, ne = s((e) => e), Do = p(xt, {
  resolve: (e) => {
    var n, o, i;
    const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.watched) == null ? void 0 : o.remove;
    if ((t == null ? void 0 : t.status) === "FAIL")
      throw new I(((i = t.error) == null ? void 0 : i.message) ?? "Failed to remove movie watched");
    return {
      watched: !1
    };
  },
  hydrate: ne
}), Uo = p(Ht, {
  resolve: (e) => {
    var n, o, i;
    const t = (o = (n = e == null ? void 0 : e.movie) == null ? void 0 : n.watched) == null ? void 0 : o.set;
    if ((t == null ? void 0 : t.status) === "FAIL")
      throw new I(((i = t.error) == null ? void 0 : i.message) ?? "Failed to set movie watched");
    return {
      watched: !0
    };
  },
  hydrate: ne
}), Yt = s((e) => {
  const t = "id" in e.entity ? e.entity.id : "", n = "title" in e.entity ? e.entity.title ?? "" : "";
  return {
    cover: e.cover ? g(e.cover) : null,
    id: t,
    title: n
  };
}), Qt = s(
  ({ data: e, showcaseId: t }) => {
    var i, r, a;
    const n = t ? `${e.id}/${t}` : e.id, o = ((r = (i = e.content) == null ? void 0 : i.items) == null ? void 0 : r.reduce((l, c) => (c && "entity" in c && l.push(Yt(c)), l), [])) ?? [];
    return {
      typename: e.__typename,
      type: "multi",
      id: e.id,
      showcaseId: t,
      key: n,
      title: e.title ?? "",
      sessionId: ((a = e.content) == null ? void 0 : a.sessionId) ?? "",
      items: o
    };
  }
), Gt = s(
  ({ data: e, showcaseId: t }) => ({
    ...U({ data: e, showcaseId: t }),
    type: "top10"
  })
), Xt = s((e) => {
  if (!("movie" in e) || !e.movie)
    throw new Error("Invalid data");
  return {
    movie: M(e.movie),
    backgroundCover: e.backgroundCover ? g(e.backgroundCover) : null,
    finishCover: e.finishCover ? g(e.finishCover) : null,
    startCover: e.startCover ? g(e.startCover) : null
  };
}), Kt = s(
  ({ data: e, showcaseId: t }) => {
    var i, r, a, l;
    const n = t ? `${e.id}/${t}` : e.id, o = ((r = (i = e.content) == null ? void 0 : i.items) == null ? void 0 : r.reduce((c, m) => (m && "movie" in m && m.movie && c.push(Xt(m)), c), [])) ?? [];
    return {
      typename: e.__typename,
      type: "originals",
      id: e.id,
      showcaseId: t,
      key: n,
      title: e.title ?? "",
      sessionId: ((a = e.content) == null ? void 0 : a.sessionId) ?? "",
      hasMore: ((l = e.content) == null ? void 0 : l.hasMore) ?? !1,
      items: o
    };
  }
), jt = s((e) => {
  if (!("movie" in e) || !e.movie)
    throw new Error("Invalid data");
  const t = e.movie, n = f(t.title), o = t.shortDescription ?? "", i = t.gallery.covers.horizontal ? g(t.gallery.covers.horizontal) : null, r = t.gallery.logos.horizontal ? g(t.gallery.logos.horizontal) : null, a = "videoCoverLogos" in e ? e.videoCoverLogos : e.coverLogos, l = a == null ? void 0 : a.find(
    (m) => (m == null ? void 0 : m.theme) === e.coverLogoRecommendedTheme && m.formFactor === "M"
  ), c = l != null && l.image ? g(l.image) : null;
  return {
    type: "movie",
    id: t.id,
    contentId: t.contentId ?? "",
    title: n,
    shortDescription: o,
    cover: i,
    logo: r,
    badge: c,
    videoContentId: e.videoContentId
  };
}), Zt = s((e) => {
  if (!e.promoTvChannel)
    throw new Error("Invalid data");
  return {
    type: "channelProgram",
    finishTime: new Date(e.promoTvChannel.finishTime).getTime(),
    channel: $({
      tvChannel: e.promoTvChannel,
      tvPrograms: e.promoTvPrograms
    })
  };
}), Jt = s(
  ({ data: e, showcaseId: t }) => {
    var i, r, a;
    const n = t ? `${e.id}/${t}` : e.id, o = ((r = (i = e.content) == null ? void 0 : i.items) == null ? void 0 : r.reduce((l, c) => (c && "movie" in c && c.movie ? l.push(jt(c)) : c && "promoTvChannel" in c && c.promoTvChannel && l.push(Zt(c)), l), [])) ?? [];
    return {
      typename: e.__typename,
      type: "promo",
      id: e.id,
      showcaseId: t,
      key: n,
      title: e.title ?? "",
      sessionId: ((a = e.content) == null ? void 0 : a.sessionId) ?? "",
      items: o
    };
  }
), qt = s(({ data: e, showcaseId: t }) => ({
  typename: e.__typename,
  type: "cw",
  id: e.id,
  showcaseId: t,
  key: t ? `${e.id}/${t}` : e.id,
  title: e.title ?? ""
})), en = s((e) => {
  if (!("showcaseReference" in e))
    throw new Error("Invalid data");
  return {
    id: e.showcaseReference.id,
    title: e.showcaseReference.title,
    logo: g(e.showcaseReference.gallery.logos.dynamic),
    gradient: g(e.showcaseReference.gallery.logos.gradient),
    background: g(e.showcaseReference.gallery.backgrounds.main)
  };
}), tn = s(({ data: e, showcaseId: t }) => {
  var i, r, a, l;
  const n = t ? `${e.id}/${t}` : e.id, o = ((r = (i = e.content) == null ? void 0 : i.items) == null ? void 0 : r.reduce((c, m) => (m && "showcaseReference" in m && m.showcaseReference && c.push(en(m)), c), [])) ?? [];
  return {
    typename: e.__typename,
    type: "showcases",
    id: e.id,
    showcaseId: t,
    key: n,
    title: e.title ?? "",
    sessionId: ((a = e.content) == null ? void 0 : a.sessionId) ?? "",
    hasMore: ((l = e.content) == null ? void 0 : l.hasMore) ?? !1,
    items: o
  };
}), nn = s(({ gallery: e, owner: t }) => ({
  logo: t != null && t.gallery.logos.centeredMain ? g(t.gallery.logos.centeredMain) : null,
  background: g(e.backgrounds.main)
})), on = s(({ showcaseId: e, data: t }) => {
  var i, r, a;
  const n = e ? `${t.id}/${e}` : t.id, o = (((i = t.content) == null ? void 0 : i.items) ?? []).reduce((l, c) => {
    if (c && "tvChannel" in c && c.tvChannel) {
      const m = $({
        tvChannel: c.tvChannel,
        tvPrograms: c.tvPrograms
      });
      m.programs.length && l.push(m);
    }
    return l;
  }, []);
  return {
    typename: t.__typename,
    type: "channelPrograms",
    id: t.id,
    showcaseId: e,
    key: n,
    title: t.title ?? "",
    sessionId: ((r = t.content) == null ? void 0 : r.sessionId) ?? "",
    hasMore: ((a = t.content) == null ? void 0 : a.hasMore) ?? !1,
    items: o
  };
}), rn = s(
  (e) => {
    var i, r, a, l;
    const n = (((i = e.content) == null ? void 0 : i.items) ?? []).reduce((c, m) => {
      if (!m || !("__typename" in m))
        return c;
      let u;
      switch (m.__typename) {
        case "PromoSelection": {
          u = Jt({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "ContinueWatchingEmbeddedSelection":
          u = qt({
            data: m,
            showcaseId: e.id
          });
          break;
        case "Selection":
        case "AnnounceSelection":
        case "WatchLaterSelection": {
          u = U({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "OttTopSelection": {
          u = Gt({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "OriginalsSelection": {
          u = Kt({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "MultiSelection": {
          u = Qt({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "StyledShowcasesSelection": {
          u = tn({
            data: m,
            showcaseId: e.id
          });
          break;
        }
        case "ChannelProgramsSelection": {
          u = on({
            data: m,
            showcaseId: e.id
          });
          break;
        }
      }
      return ((u == null ? void 0 : u.type) === "cw" || u != null && u.items.length) && c.push(u), c;
    }, []), o = e.__typename === "StyledShowcase" ? nn(e) : null;
    return {
      typename: e.__typename,
      id: e.id,
      title: e.title ?? "",
      sessionId: ((r = e.content) == null ? void 0 : r.sessionId) ?? "",
      offset: ((a = e.content) == null ? void 0 : a.offset) ?? 0,
      hasMore: ((l = e.content) == null ? void 0 : l.hasMore) ?? !1,
      selections: n,
      styledMeta: o
    };
  }
), an = {
  name: "Showcase",
  body: "query Showcase($id: String!, $offset: Int, $limit: Int, $selectionOffset: Int, $selectionLimit: Int, $withUserData: Boolean!, $withRating: Boolean!, $withStyledShowcasesSelection: Boolean!) { showcase(id: $id) { __typename id title ...StyledShowcaseMeta content(offset: $offset, limit: $limit) { offset hasMore sessionId items { ... on PromoSelection { ...PromoSelection } ... on ContinueWatchingEmbeddedSelection { ...ContinueWatchingSelection } ... on Selection { ...DefaultSelection } ... on AnnounceSelection { ...DefaultSelection } ... on WatchLaterSelection { ...DefaultSelection } ... on OttTopSelection { ...DefaultSelection } ... on OriginalsSelection { ...OriginalsSelection } ... on MultiSelection { ...MultiSelection } ... on StyledShowcasesSelection @include(if: $withStyledShowcasesSelection) { ...StyledShowcasesSelection } ... on ChannelProgramsSelection { ...ChannelProgramsSelection } } } } } fragment StyledShowcaseMeta on StyledShowcase { gallery { backgrounds { main { ...Image } } } owner { ... on ContentBrand { gallery { logos { centeredMain { ...Image } } } } } } fragment Image on Image { avatarsUrl fallbackUrl } fragment PromoSelection on PromoSelection { __typename id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId items { ...PromoBlock ...PromoBlockAnnounce ...PromoBlockVideo ...PromoTvChannelProgram } } } fragment PromoBlock on PromoSelectionItem { videoContentId coverLogoRecommendedTheme coverLogos { formFactor image { ...Image } theme } movie { ...PromoBlockMovie } } fragment PromoBlockMovie on Movie { id contentId title { ...Title } shortDescription gallery { covers { horizontal { ...Image } } logos { horizontal { ...Image } } } } fragment Title on Title { localized original } fragment PromoBlockAnnounce on PromoAnnounceSelectionItem { videoContentId coverLogoRecommendedTheme coverLogos { formFactor image { ...Image } theme } movie { ...PromoBlockMovie } } fragment PromoBlockVideo on VideoMovieSelectionItem { videoContentId coverLogoRecommendedTheme videoCoverLogos: coverLogos { formFactor image { ...Image } theme } movie { ...PromoBlockMovie } } fragment PromoTvChannelProgram on PromoTvChannelProgramSelectionItem { promoTvChannel { contentId title logo { ...Image } finishTime } promoTvPrograms { id title startTime endTime typeName ageRestriction image { ...Image } } } fragment ContinueWatchingSelection on ContinueWatchingEmbeddedSelection { __typename id title } fragment DefaultSelection on AbstractSelection { __typename id title comment content(offset: $selectionOffset, limit: $selectionLimit) { offset hasMore sessionId items { ...SelectionEntity } } } fragment SelectionEntity on SelectionItem { __typename ... on AbstractMovieSelectionItem { movie { ...SelectionMovie } ... on SeasonAnnounceSelectionItem { season { viewOption { availabilityAnnounce { ...SelectionAvailabilityAnnounce } } } } } } fragment SelectionMovie on Movie { id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } verticalIntro { ...Image } verticalIntroWithRightholderLogo { ...Image } horizontal { ...Image } horizontalWithRightholderLogo { ...Image } horizontalIntro { ...Image } horizontalIntroWithRightholderLogo { ...Image } } } viewOption { ...SelectionViewOption availabilityAnnounce { ...SelectionAvailabilityAnnounce } } ratingLists { top10 { position } } userData @include(if: $withUserData) { ...SelectionUserData } rating @include(if: $withRating) { kinopoisk { ...RatingValue } } } fragment SelectionViewOption on ViewOption { purchasabilityStatus watchabilityStatus subscriptionBadge { image { ...Image } } } fragment SelectionAvailabilityAnnounce on AvailabilityAnnounce { availabilityDate announcePromise } fragment SelectionUserData on MovieUserData { isPlannedToWatch } fragment RatingValue on RatingValue { __typename value isActive count } fragment OriginalsSelection on OriginalsSelection { __typename id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId hasMore items { ...OriginalsSelectionEntity ...OriginalsSelectionAnnounceEntity } } } fragment OriginalsSelectionEntity on OriginalMovieSelectionItem { movie { ...SelectionMovie } backgroundCover { ...Image } finishCover { ...Image } startCover { ...Image } } fragment OriginalsSelectionAnnounceEntity on OriginalAnnounceMovieSelectionItem { movie { ...SelectionMovie } backgroundCover { ...Image } finishCover { ...Image } startCover { ...Image } } fragment MultiSelection on MultiSelection { __typename id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId items { ...MultiSelectionEntity } } } fragment MultiSelectionEntity on LinkSelectionItem { cover { ...Image } entity { ... on AbstractSelection { id title } } } fragment StyledShowcasesSelection on StyledShowcasesSelection { __typename id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId hasMore items { ...StyledShowcasesEntity } } } fragment StyledShowcasesEntity on StyledShowcaseSelectionItem { showcaseReference { id title gallery { logos { dynamic { ...Image } gradient { ...Image } } backgrounds { main { ...Image } } } } } fragment ChannelProgramsSelection on ChannelProgramsSelection { __typename id title content(offset: $selectionOffset, limit: $selectionLimit) { sessionId hasMore items { ... on TvChannelProgramSelectionItem { tvChannel { ...TvChannel gallery { covers { horizontal { ...Image } } } } tvPrograms { ...TvChannelProgram image { ...Image } } } } } } fragment TvChannel on TvChannel { contentId viewOption { ...TvChannelViewOption } title gallery { logos { main { ...Image } } } } fragment TvChannelViewOption on ViewOption { ...ViewOptionBase subscriptionBadge { image { ...Image } } } fragment ViewOptionBase on ViewOption { type watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties } fragment TvChannelProgram on TvProgram { id title startTime endTime typeName }",
  get variables() {
  },
  get query() {
  }
}, Bo = p(an, {
  resolve: (e) => e == null ? void 0 : e.showcase,
  hydrate: (e) => e ? rn(e) : null
}), sn = s((e) => ({
  get isPurchased() {
    return e.purchasabilityStatus === "PURCHASED";
  }
})), ln = s((e) => {
  const { start: t, end: n } = e.releaseYears[0] ?? {};
  return {
    start: t,
    end: n,
    toString() {
      return n && t !== n ? t ? `${t}-${n}` : null : t ? `${t} - ...` : null;
    }
  };
}), B = s(
  (e) => {
    var m, u;
    const t = f(e.title), n = e.gallery.posters, o = n.verticalWithRightholderLogo ?? n.vertical, i = o ? g(o) : null, r = e.viewOption ? sn(e.viewOption) : null;
    let a = null, l = !1;
    "productionYear" in e ? a = ((m = e.productionYear) == null ? void 0 : m.toString()) ?? null : "releaseYears" in e && (a = ln(e).toString() ?? null, l = !0);
    const c = (u = e.viewOption) != null && u.availabilityAnnounce ? W(e.viewOption.availabilityAnnounce) : null;
    return {
      id: e.id,
      contentId: e.contentId ?? "",
      year: a,
      isSeries: l,
      poster: i,
      title: t,
      viewOption: r,
      availabilityAnnounce: c
    };
  }
), cn = s(
  (e) => {
    var o;
    if (!e)
      return { history: [] };
    const t = e.history;
    return {
      history: ((o = t == null ? void 0 : t.items) == null ? void 0 : o.reduce((i, r) => (r.entity && "id" in r.entity && i.push(B(r.entity)), i), [])) ?? []
    };
  }
), mn = {
  name: "SuggestEmptyPrefix",
  body: "query SuggestEmptyPrefix($historyLimit: Int) { emptyPrefixSuggest { history(limit: $historyLimit) { items { entity { ...SuggestMovieItem } } } } } fragment SuggestMovieItem on Movie { __typename id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } } } viewOption { ...SuggestViewOption availabilityAnnounce { ...AvailabilityAnnounce } } ... on Film { productionYear(override: OTT_WHEN_EXISTS) } ... on Series { ...ReleaseYears } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SuggestViewOption on ViewOption { purchasabilityStatus } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise } fragment ReleaseYears on Series { releaseYears { start end } }",
  get variables() {
  },
  get query() {
  }
}, ko = p(mn, {
  resolve: (e) => e == null ? void 0 : e.emptyPrefixSuggest,
  hydrate: (e) => cn(e)
}), un = s(
  (e) => {
    const t = e.poster, n = t ? g(t) : void 0;
    return {
      id: e.id,
      name: e.name ?? "",
      originalName: e.originalName ?? "",
      birthDate: e.birthDate ?? void 0,
      posterUrl: n
    };
  }
), gn = s(
  (e) => {
    var o, i, r, a;
    if (!e)
      return { movies: [], persons: [] };
    const t = ((i = (o = e.movies) == null ? void 0 : o.items) == null ? void 0 : i.reduce((l, c) => (c != null && c.movie && l.push(B(c.movie)), l), [])) ?? [], n = ((a = (r = e.persons) == null ? void 0 : r.items) == null ? void 0 : a.reduce((l, c) => (c != null && c.person && l.push(un(c.person)), l), [])) ?? [];
    return {
      movies: t,
      persons: n
    };
  }
), pn = {
  name: "SuggestSearch",
  body: "query SuggestSearch($keyword: String!, $limit: Int, $onlySearchable: Boolean = false, $onlyAvailableMe: Boolean = false) { suggest(keyword: $keyword) { movies( limit: $limit isOnline: true onlySearchable: $onlySearchable onlyAvailableMe: $onlyAvailableMe ) { items { movie { ...SuggestMovieItem } } } persons(limit: $limit, onlyWithOnlines: true) { items { person { ...SuggestPersonItem } } } } } fragment SuggestMovieItem on Movie { __typename id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } } } viewOption { ...SuggestViewOption availabilityAnnounce { ...AvailabilityAnnounce } } ... on Film { productionYear(override: OTT_WHEN_EXISTS) } ... on Series { ...ReleaseYears } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SuggestViewOption on ViewOption { purchasabilityStatus } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise } fragment ReleaseYears on Series { releaseYears { start end } } fragment SuggestPersonItem on Person { id name originalName birthDate poster { ...Image } }",
  get variables() {
  },
  get query() {
  }
}, No = p(pn, {
  resolve: (e) => e == null ? void 0 : e.suggest,
  hydrate: (e) => gn(e)
}), dn = s(
  (e) => {
    var n, o;
    return e ? {
      movies: ((o = (n = e.content) == null ? void 0 : n.items) == null ? void 0 : o.reduce((i, r) => (r && "movie" in r && r.movie && i.push(B(r.movie)), i), [])) ?? []
    } : { movies: [] };
  }
), vn = {
  name: "SuggestSelection",
  body: "query SuggestSelection($selectionLimit: Int, $selectionId: String!) { selection(id: $selectionId) { id title content(limit: $selectionLimit) { items { ... on AbstractMovieSelectionItem { movie { ...SuggestMovieItem } } } } } } fragment SuggestMovieItem on Movie { __typename id contentId title { ...Title } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } verticalWithRightholderLogo { ...Image } } } viewOption { ...SuggestViewOption availabilityAnnounce { ...AvailabilityAnnounce } } ... on Film { productionYear(override: OTT_WHEN_EXISTS) } ... on Series { ...ReleaseYears } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment SuggestViewOption on ViewOption { purchasabilityStatus } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise } fragment ReleaseYears on Series { releaseYears { start end } }",
  get variables() {
  },
  get query() {
  }
}, Vo = p(vn, {
  resolve: (e) => e == null ? void 0 : e.selection,
  hydrate: (e) => dn(e)
}), hn = s((e) => {
  var t;
  return {
    timingsAuthToken: ((t = e.userProfileCredentials) == null ? void 0 : t.timingsAuthToken) ?? null,
    profileId: e.id.ottId
  };
}), fn = {
  name: "TimingsUserCredentials",
  body: "query TimingsUserCredentials { userProfile { id { ottId kpId puid } userProfileCredentials { timingsAuthToken } } }",
  get variables() {
  },
  get query() {
  }
}, Fo = p(fn, {
  resolve: (e) => (e == null ? void 0 : e.userProfile) ?? null,
  hydrate: (e) => e ? hn(e) : null
}), Sn = s(
  (e) => {
    var o;
    const t = (o = e.userProfile) == null ? void 0 : o.watchingHistory, n = (t == null ? void 0 : t.items.reduce((i, r) => {
      if (r.entity === null)
        return i;
      const a = r.entity.__typename;
      let l = null;
      switch (a) {
        case "Episode":
          l = E({ type: "episode", data: r.entity });
          break;
        case "Film":
        case "Video":
          l = E({ type: "movie", data: r.entity });
          break;
      }
      return l && i.push({
        date: r.date,
        entity: l
      }), i;
    }, [])) ?? [];
    return {
      currentDate: e.clientInfo.time.currentDate,
      hasMore: !!(t != null && t.hasMore),
      nextCursor: (t == null ? void 0 : t.nextCursor) ?? void 0,
      items: n
    };
  }
), yn = {
  name: "WatchingHistory",
  body: "query WatchingHistory($cursor: String, $limit: Int) { clientInfo { time { currentDate } } userProfile { watchingHistory(cursor: $cursor, limit: $limit) { ...WatchingHistory } } } fragment WatchingHistory on CursorPagingList_WatchingHistoryItem_String { hasMore nextCursor items { date entity { __typename ...WatchingMovie ...WatchingEpisode } } } fragment WatchingMovie on Movie { id contentId title { ...Title } ott { preview { __typename ... on OttPreview_AbstractVideo { duration timing { current maximum } } } } gallery { covers { horizontal { ...Image } } } viewOption { ...WatchingViewOption } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment WatchingViewOption on ViewOption { purchasabilityStatus purchaseOptionCustomProperties watchPeriod { timeToExpire watchPeriodStatus } watchabilityStatus subscriptionBadge { image { ...Image } } } fragment WatchingEpisode on Episode { contentId title { ...Title } number season { contentId number } cover { ...Image } ott { duration timing { current maximum } } viewOption { ...WatchingViewOption } tvSeries { contentId title { ...Title } viewOption { ...WatchingViewOption } } }",
  get variables() {
  },
  get query() {
  }
}, zo = p(yn, {
  resolve: (e) => e,
  hydrate: (e) => {
    var t;
    return (t = e == null ? void 0 : e.userProfile) != null && t.watchingHistory ? Sn(e) : null;
  }
}), oe = s((e) => {
  var t;
  return {
    duration: e.duration ?? 0,
    currentTime: ((t = e.timing) == null ? void 0 : t.current) ?? 0
  };
}), In = s(
  (e) => {
    var t, n, o, i;
    return {
      contentId: e.episode.contentId ?? "",
      fallback: e.fallback,
      episodeNumber: e.episode.number,
      seasonNumber: ((t = e.episode.season) == null ? void 0 : t.number) ?? void 0,
      title: f(e.episode.title),
      cover: e.episode.cover ? g(e.episode.cover) : null,
      progress: oe({
        duration: (n = e.episode.ott) == null ? void 0 : n.duration,
        timing: (o = e.episode.ott) == null ? void 0 : o.timing
      }),
      availability: (i = e.episode.ott) != null && i.viewOption ? {
        availabilityEndDate: e.episode.ott.viewOption.availabilityEndDate ?? null,
        availabilityStatus: e.episode.ott.viewOption.availabilityStatus ?? null
      } : null
    };
  }
), bn = s(
  (e) => {
    var a, l;
    const t = e.ott, n = e.__typename;
    let o = null, i = null;
    const r = (n === "TvSeries" || n === "TvShow" || n === "MiniSeries") && t && "nextEpisode" in t && ((a = t.nextEpisode) != null && a.episode) ? {
      fallback: t.nextEpisode.fallback,
      episode: t.nextEpisode.episode
    } : null;
    return r && (o = In(r)), ((l = t == null ? void 0 : t.preview) == null ? void 0 : l.__typename) === "OttPreview_AbstractVideo" && (i = oe({
      duration: t.preview.duration,
      timing: t.preview.timing
    })), {
      nextEpisode: o,
      movieProgress: i
    };
  }
), wn = {
  name: "WatchingProgress",
  body: "query WatchingProgress($contentId: String!) { movieByContentUuid(contentUuid: $contentId) { ott { ...NextEpisode ...MovieProgress } __typename } } fragment NextEpisode on Ott { ... on Ott_AbstractSeries { nextEpisode(fallbackToFirstEpisode: true) { fallback episode { id contentId number title { ...Title } cover { ...Image } ott { duration timing { current } viewOption { availabilityEndDate availabilityStatus } } season { id contentId number } } } } } fragment Title on Title { localized original } fragment Image on Image { avatarsUrl fallbackUrl } fragment MovieProgress on Ott { preview { ... on OttPreview_AbstractVideo { timing { current } duration __typename } __typename } }",
  get variables() {
  },
  get query() {
  }
}, xo = p(wn, {
  resolve: (e) => (e == null ? void 0 : e.movieByContentUuid) ?? null,
  hydrate: (e) => e ? bn(e) : null
}), Tn = s(
  ({ data: e, experimentHandler: t = "YANGO_PLAY_WEB_MOVIES" }) => {
    var i;
    const n = {
      ...ae(e),
      flags: {},
      testIds: [],
      grouped: {}
    }, o = e.experiments.rawHandlers.concat(
      e.featureToggles.rawHandlers
    );
    for (const r of o) {
      const a = r.HANDLER;
      if (!a || a !== t)
        continue;
      const l = (i = r.CONTEXT) == null ? void 0 : i[a];
      if (!l)
        continue;
      const c = l.name, m = l.flags, u = r.TESTID;
      if (m)
        for (const [d, v] of Object.entries(m))
          n.flags[d] = v;
      if (u && Array.isArray(u))
        for (const d of u)
          n.testIds.push(d), c && m && (n.grouped[c] || (n.grouped[c] = {}), n.grouped[c][d] = m);
    }
    return n;
  }
), Pn = s(
  (e) => ({
    remoteConfig: e.remoteConfig ? se(e.remoteConfig) : null,
    experiments: e.experiments ? Tn({
      data: e.experiments,
      experimentHandler: e.experimentHandler
    }) : null,
    userProfile: e.userProfile ? le(e.userProfile) : null,
    clientInfo: e.clientInfo
  })
), Ho = p(me, {
  resolve: (e, t, n) => ({
    ...ce.resolve(e, t),
    experimentHandler: n == null ? void 0 : n.experimentHandler
  }),
  hydrate: (e) => Pn(e)
}), Mn = {
  name: "YangoCrossRedirect",
  body: "query YangoCrossRedirect($id: Long!) { movie(id: $id) { id contentId } }",
  get variables() {
  },
  get query() {
  }
}, Yo = p(Mn), Cn = s((e) => {
  var a;
  const t = e.covers.horizontal ? g(e.covers.horizontal) : null, n = e.covers.square ? g(e.covers.square) : null, o = e.logos.horizontal ? g(e.logos.horizontal) : null, i = (a = e.logos.rightholderForCover) == null ? void 0 : a.find(
    (l) => l.theme === e.logos.rightholderForCoverRecommendedTheme
  ), r = i != null && i.image ? g(i.image) : null;
  return {
    horizontalCover: t,
    squareCover: n,
    horizontalLogo: o,
    recommendedRightholderLogo: r
  };
}), On = s((e) => {
  var i, r, a, l;
  const t = f(e.title), n = e.restriction ? P(e.restriction) : null, o = "releaseYears" in e ? D(e) : null;
  return {
    typename: e.__typename,
    contentId: e.contentId,
    title: t,
    shortDescription: e.shortDescription,
    editorAnnotation: e.editorAnnotation,
    genres: e.genres,
    countries: e.countries,
    ageRestriction: n,
    duration: (i = e.ott) != null && i.preview && "duration" in e.ott.preview ? e.ott.preview.duration : null,
    seasonCount: "seasonsAll" in e ? (r = e.seasonsAll) == null ? void 0 : r.total : null,
    top10Position: ((l = (a = e.ratingLists) == null ? void 0 : a.top10) == null ? void 0 : l.position) ?? null,
    productionYear: "productionYear" in e ? e.productionYear : null,
    releaseYears: o
  };
}), An = s((e) => {
  var t, n, o;
  return {
    id: ((t = e.person) == null ? void 0 : t.id) ?? null,
    name: ((n = e.person) == null ? void 0 : n.name) ?? null,
    originalName: ((o = e.person) == null ? void 0 : o.originalName) ?? null,
    toString() {
      var i, r;
      return ((i = e.person) == null ? void 0 : i.name) ?? ((r = e.person) == null ? void 0 : r.originalName) ?? "";
    }
  };
}), Q = s((e) => {
  var n;
  const t = ((n = e.items) == null ? void 0 : n.reduce((o, i) => (i != null && i.person && o.push(An(i)), o), [])) ?? [];
  return {
    total: e.total,
    items: t
  };
}), _n = s((e) => {
  const t = e.actors ? Q(e.actors) : null, n = e.directors ? Q(e.directors) : null, o = Cn(e.gallery);
  return {
    ...On(e),
    gallery: o,
    actors: t,
    directors: n
  };
}), Rn = s(
  (e) => {
    var o, i, r, a;
    const t = D(e);
    return {
      seoType: "series",
      seasonsCount: ((o = e.viewOption) != null && o.isAvailableOnline ? (i = e.seasonsOnline) == null ? void 0 : i.total : (r = e.seasonsAll) == null ? void 0 : r.total) ?? 0,
      releaseYears: t,
      country: ((a = e.countries[0]) == null ? void 0 : a.name) ?? null
    };
  }
), En = s((e) => {
  var t;
  return {
    seoType: "film",
    kpProductionYear: e.kpProductionYear,
    ottProductionYear: e.productionYear,
    country: ((t = e.countries[0]) == null ? void 0 : t.name) ?? null,
    duration: e.duration
  };
}), $n = s((e) => {
  const t = f(e.title);
  let n = null;
  return (e.__typename === "MiniSeries" || e.__typename === "TvSeries" || e.__typename === "TvShow") && (n = Rn(e)), e.__typename === "Film" && (n = En(e)), {
    typename: e.__typename,
    contentId: e.contentId,
    title: t,
    genreNames: e.genres.map((o) => o.name),
    description: e.shortDescription ?? e.synopsis,
    movieSeo: n
  };
}), Ln = s((e) => {
  var n, o;
  const t = (o = (n = e.openGraph) == null ? void 0 : n.image) == null ? void 0 : o.avatarsUrl;
  return {
    imageUrl: t ? `https:${t}` : null
  };
}), Wn = s((e) => {
  var n, o;
  const t = (o = (n = e.webPage) == null ? void 0 : n.sparkMoviePageByContentId) == null ? void 0 : o.htmlMeta;
  return {
    htmlMeta: t ? Ln(t) : null
  };
}), Dn = s(({ movie: e, webPage: t }) => ({
  movie: e ? $n(e) : null,
  page: t ? Wn(t) : null
})), Un = s((e) => ({
  movieCard: e.movieCard ? _n(e.movieCard) : null,
  movieSeo: Dn(e.movieSeo),
  viewOption: e.viewOption ? ue(e.viewOption) : null
})), Bn = {
  name: "YangoTouchFilmPage",
  body: "query YangoTouchFilmPage($contentUuid: String!, $clientContext: BillingFeatureClientContextInput!, $checkSilentInvoiceAvailability: Boolean!, $withPurchaseOptions: Boolean!) { movieByContentUuid(contentUuid: $contentUuid) { ...YangoTouchMovieCard ...YangoTouchMovieSeo viewOption { ...ViewOption } } ...YangoTouchPageSeo } fragment YangoTouchMovieCard on Movie { ...MovieCardContent gallery { ...MovieCardGallery } actors: members(limit: 5, role: [ACTOR, CAMEO, UNCREDITED]) { ...FilmCrewMemberList } directors: members(role: DIRECTOR, limit: 2) { ...FilmCrewMemberList } } fragment MovieCardContent on Movie { __typename contentId title { ...Title } shortDescription editorAnnotation genres { id name } countries { id name } restriction { ...AgeRestriction } ... on Series { seasonsAll: seasons(limit: 0) { total } } ratingLists { top10 { position } } ...MovieDuration ...MovieYears } fragment Title on Title { localized original } fragment AgeRestriction on Restriction { age } fragment MovieDuration on Movie { ott { preview { __typename ... on OttPreview_AbstractVideo { duration } } } } fragment MovieYears on Movie { __typename ... on VideoInterface { productionYear(override: OTT_WHEN_EXISTS) } ... on Series { releaseYears { start end } } } fragment MovieCardGallery on MovieGallery { covers { horizontal { ...Image } square { ...Image } } logos { horizontal { ...Image ...ImageSize } rightholderForCover(filter: {formFactor: M}) { image { ...Image } theme } rightholderForCoverRecommendedTheme } } fragment Image on Image { avatarsUrl fallbackUrl } fragment ImageSize on Image { origSize { width height } } fragment FilmCrewMemberList on PagingList_FilmCrewMember { items { ...FilmCrewMember } total } fragment FilmCrewMember on FilmCrewMember { person { id name originalName } } fragment YangoTouchMovieSeo on Movie { __typename contentId title { ...Title } viewOption { isAvailableOnline: isWatchable(filter: {anyDevice: false, anyRegion: false}) } ... on Series { releaseYears { start end } seasonsAll: seasons(limit: 0) { total } seasonsOnline: seasons(limit: 0, isOnlyOnline: true) { total } } ... on VideoInterface { duration kpProductionYear: productionYear(override: DISABLED) productionYear(override: OTT_WHEN_EXISTS) } gallery { posters { vertical(override: OTT_WHEN_EXISTS) { ...Image } } } ott { promoTrailers: trailers(onlyPromo: true, limit: 1) { items { streamUrl } } } countries { id name } shortDescription synopsis genres { id name slug } } fragment ViewOption on ViewOption { ...ViewOptionBase texts { disclaimer } contentPackageToBuy { billingFeatureName } availabilityAnnounce { ...AvailabilityAnnounce } watchPeriod { timeToExpire watchPeriodStatus } purchaseOptions(clientContext: $clientContext) @include(if: $withPurchaseOptions) { ...SubscriptionPurchaseOptions } purchaseOptionCustomProperties } fragment ViewOptionBase on ViewOption { type watchabilityStatus purchasabilityStatus purchaseOptionCustomProperties } fragment AvailabilityAnnounce on AvailabilityAnnounce { type availabilityDate announcePromise } fragment SubscriptionPurchaseOptions on BillingFeaturePurchaseOptions { target billingFeatureNames interfaceMeta subscriptionCompositeOffers( checkSilentInvoiceAvailability: $checkSilentInvoiceAvailability ) { ...SubscriptionCompositeOffers } } fragment SubscriptionCompositeOffers on SubscriptionCompositeOffers { batchPositionId eventSessionId offers { compositeOffer { ...CompositeOffer } customPayload { overridedText overridedAdditionalText } } } fragment CompositeOffer on PlusCompositeOffer { asset { subscriptionName } positionId structureType silentInvoiceAvailable forActiveOffers { ... on PlusOptionOffer { name } ... on PlusTariffOffer { name } } optionOffers { text additionText commonPeriod name option { name } plans { ...CompositeOffersPlan } } tariffOffer { text additionText commonPeriod name tariff { name } plans { ...CompositeOffersPlan } } invoices { timestamp totalPrice { amount currency } } } fragment CompositeOffersPlan on OfferPlanUnion { __typename ... on TrialUntilPlan { until } ... on IntroUntilPlan { until } ... on TrialPlan { period } ... on IntroPlan { period } } fragment YangoTouchPageSeo on Query { webPage(platform: TOUCH) { sparkMoviePageByContentId(contentId: $contentUuid) { htmlMeta { openGraph { image { avatarsUrl } } } } } }",
  get variables() {
  },
  get query() {
  }
}, Qo = p(Bn, {
  resolve: (e) => {
    var t;
    return {
      movieCard: (e == null ? void 0 : e.movieByContentUuid) ?? null,
      movieSeo: { movie: (e == null ? void 0 : e.movieByContentUuid) ?? null, webPage: e ?? null },
      viewOption: ((t = e == null ? void 0 : e.movieByContentUuid) == null ? void 0 : t.viewOption) ?? null
    };
  },
  hydrate: (e) => Un(e)
}), kn = s((e) => {
  var t;
  return {
    isPlannedToWatch: ((t = e.userData) == null ? void 0 : t.isPlannedToWatch) ?? !1,
    title: f(e.title),
    contentId: e.contentId
  };
}), Nn = {
  name: "MoviePlannedToWatch",
  body: "query MoviePlannedToWatch($movieId: Long!, $isAuthorized: Boolean!) { movie(id: $movieId) { ...MoviePlannedToWatch } } fragment MoviePlannedToWatch on Movie { id contentId title { ...Title } userData @include(if: $isAuthorized) { isPlannedToWatch } } fragment Title on Title { localized original }",
  get variables() {
  },
  get query() {
  }
}, Go = p(Nn, {
  resolve: (e) => e == null ? void 0 : e.movie,
  hydrate: (e) => e ? kn(e) : null
}), Vn = {
  name: "SetWatchParams",
  body: "mutation SetWatchParams($input: WatchParamsInput!) { watchParams { saveByParams(input: $input) { error { message } status } } }",
  get variables() {
  },
  get query() {
  }
}, Xo = p(
  Vn,
  {
    resolve: (e) => {
      var t;
      return (t = e == null ? void 0 : e.watchParams) == null ? void 0 : t.saveByParams;
    }
  }
), Fn = {
  name: "SaveLastWatchedChannel",
  body: "mutation SaveLastWatchedChannel($contentId: String!) { tvChannel { lastSeen { save(input: {contentId: $contentId}) { status error { message } } } } }",
  get variables() {
  },
  get query() {
  }
}, Ko = p(
  Fn,
  {
    resolve: (e) => {
      var t, n;
      return (n = (t = e == null ? void 0 : e.tvChannel) == null ? void 0 : t.lastSeen) == null ? void 0 : n.save;
    }
  }
), zn = s(({ data: e }) => {
  const {
    id: t,
    name: n,
    sportType: o,
    shortName: i
  } = e, r = g(e.gallery.covers.main), a = g(e.gallery.covers.clean), l = g(e.gallery.backgrounds.accentRight), c = g(e.gallery.backgrounds.accentRightSquare), m = g(e.gallery.logos.main);
  return {
    id: t,
    name: n,
    shortName: i,
    coverMain: r,
    coverClean: a,
    backgroundAccentRight: l,
    backgroundAccentRightSquare: c,
    logo: m,
    sportType: o
  };
}), xn = s(
  ({ data: e }) => {
    const {
      type: t,
      purchasabilityStatus: n,
      contentPackageToBuy: o
    } = e;
    return {
      isFree: t === "FREE",
      isPaid: t === "PAID",
      isPaidMultiple: t === "PAID_MULTIPLE",
      isSubscription: t === "SUBSCRIPTION",
      isPurchased: n === "PURCHASED",
      isPurchasable: n === "PURCHASABLE",
      type: t ?? void 0,
      billingFeatureNameToBuy: o == null ? void 0 : o.billingFeatureName,
      subscriptionBadge: e.subscriptionBadge ? g(e.subscriptionBadge.image) : void 0
    };
  }
), Hn = (e, t) => {
  const { startTime: n, endTime: o, expirationTime: i } = e, r = new Date(n), a = new Date(o), l = new Date(i), c = new Date(t);
  return c < r ? "ANNOUNCE" : c < a ? "LIVE" : c < l ? "RECORD" : "EXPIRED";
}, k = s(
  ({ data: e }) => {
    const {
      id: t,
      sportEventId: n,
      title: o,
      description: i,
      shortDescription: r,
      comment: a,
      startTime: l,
      endTime: c,
      expirationTime: m,
      competition: u
    } = e, d = g(e.gallery.covers.announce), v = g(e.gallery.covers.live), h = g(e.gallery.covers.record), S = g(e.gallery.covers.accentRight), w = g(e.gallery.covers.accentRightSquare), T = g(e.gallery.posters.announceHorizontal), b = g(e.gallery.posters.liveHorizontal), C = g(e.gallery.posters.recordHorizontal), O = g(e.gallery.posters.accentRightHorizontal), A = g(e.gallery.posters.accentRightWithLogo), _ = u ? zn({ data: u }) : void 0, R = Hn({ startTime: l, endTime: c, expirationTime: m }, (/* @__PURE__ */ new Date()).toISOString()), y = e.liveMeta ?? void 0, re = e.viewOption ? xn({ data: e.viewOption }) : void 0;
    return {
      id: t,
      sportEventId: n,
      title: o,
      startTime: l,
      endTime: c,
      expirationTime: m,
      coverAnnounce: d,
      coverLive: v,
      coverRecord: h,
      coverAccentRight: S,
      coverAccentRightSquare: w,
      posterAnnounce: T,
      posterLive: b,
      posterRecord: C,
      posterAccentRight: O,
      posterAccentRightWithLogo: A,
      competition: _,
      eventState: R,
      liveMeta: y,
      viewOption: re,
      description: i ?? void 0,
      shortDescription: r ?? void 0,
      comment: a ?? void 0
    };
  }
), G = s(({ data: e }) => {
  const t = g(e.logo);
  return {
    id: e.id,
    name: e.name,
    fullName: e.fullName,
    sportType: e.sportType ?? void 0,
    logo: t
  };
}), ie = s(({ data: e }) => {
  const t = k({ data: e }), n = G({ data: e.firstTeam }), o = G({ data: e.secondTeam });
  return {
    ...t,
    firstTeam: n,
    secondTeam: o
  };
});
var Yn = /* @__PURE__ */ ((e) => (e.Event = "event", e.TeamsEvent = "teams-event", e))(Yn || {});
const Qn = s(({ data: e }) => e.__typename === "SportTeamsEvent" ? {
  type: "teams-event",
  sportEvent: ie({ data: e })
} : {
  type: "event",
  sportEvent: k({ data: e })
}), Gn = s(
  (e) => ({
    offset: e == null ? void 0 : e.offset,
    limit: e == null ? void 0 : e.limit,
    hasMore: e == null ? void 0 : e.hasMore
  })
), Xn = s(
  ({ data: e }) => {
    var r;
    const { id: t, title: n, content: o } = e, i = [];
    return (r = o == null ? void 0 : o.items) == null || r.forEach((a) => {
      if (!a || !("__typename" in a))
        return;
      const l = Qn({ data: a.sportEvent });
      i.push(l);
    }), {
      ...Gn(e.content),
      id: t,
      items: i,
      type: "sport-promo",
      title: n ?? void 0
    };
  }
), Kn = s(
  (e) => {
    var o, i, r;
    const n = (((o = e.content) == null ? void 0 : o.items) ?? []).reduce((a, l) => {
      if (!l || !("__typename" in l))
        return a;
      let c;
      switch (l.__typename) {
        case "SportPromoSelection": {
          c = Xn({
            data: l
          });
          break;
        }
      }
      return c != null && c.items.length && a.push(c), a;
    }, []);
    return {
      typename: e.__typename,
      id: e.id,
      title: e.title ?? "",
      offset: ((i = e.content) == null ? void 0 : i.offset) ?? 0,
      hasMore: ((r = e.content) == null ? void 0 : r.hasMore) ?? !1,
      selections: n
    };
  }
), jn = {
  name: "SportShowcase",
  body: "query SportShowcase($showcaseId: String!, $offset: Int!, $limit: Int!) { sportShowcase(id: $showcaseId) { __typename id title content(offset: $offset, limit: $limit) { offset limit hasMore items { ... on SportPromoSelection { __typename ...SportPromoSelection } } } } } fragment SportPromoSelection on SportPromoSelection { ...AbstractSportSelectionData content(limit: 10, offset: 0) { ...SportSelectionPagingListData items { ... on SportEventSelectionItem { __typename ...SportEventSelectionItem } } } } fragment AbstractSportSelectionData on AbstractSelection { id showTitle title comment } fragment SportSelectionPagingListData on SessionPagingList_SelectionItem { offset limit hasMore } fragment SportEventSelectionItem on SportEventSelectionItem { sportEvent { __typename ... on SportEvent { ...AbstractSportEvent } ... on SportTeamsEvent { ...SportTeamsEvent } } } fragment AbstractSportEvent on AbstractSportEvent { id sportEventId startTime endTime expirationTime title description shortDescription comment competition { ...SportCompetition } gallery { covers { announce { ...Image } live { ...Image } record { ...Image } accentRight { ...Image } accentRightSquare { ...Image } } posters { announceHorizontal { ...Image } liveHorizontal { ...Image } recordHorizontal { ...Image } accentRightHorizontal { ...Image } accentRightWithLogo { ...Image } } } liveMeta { ...AbstractSportEventLiveMeta } viewOption { ...SportViewOption } } fragment SportCompetition on Competition { id name shortName sportType { ...SportType } gallery { backgrounds { accentRight { ...Image } accentRightSquare { ...Image } } covers { clean { ...Image } main { ...Image } } logos { main { ...Image } } } } fragment SportType on SportType { id name } fragment Image on Image { avatarsUrl fallbackUrl } fragment AbstractSportEventLiveMeta on AbstractSportEventLiveMeta { stage } fragment SportViewOption on ViewOption { type purchasabilityStatus contentPackageToBuy { billingFeatureName } subscriptionBadge { image { ...Image } } } fragment SportTeamsEvent on AbstractSportEvent { liveMeta { ... on SportTeamsEventLiveMeta { ...AbstractSportEventLiveMeta ...SportTeamsEventLiveMeta } } ... on SportTeamsEvent { ...AbstractSportEvent firstTeam { ...SportTeam } secondTeam { ...SportTeam } } } fragment SportTeamsEventLiveMeta on SportTeamsEventLiveMeta { firstTeamScore { ...TeamScore } secondTeamScore { ...TeamScore } } fragment TeamScore on SportTeamScore { result team { ...SportTeam } } fragment SportTeam on SportTeam { id logo { ...Image } name fullName sportType { ...SportType } }",
  get variables() {
  },
  get query() {
  }
}, jo = p(jn, {
  resolve: (e) => e == null ? void 0 : e.sportShowcase,
  hydrate: (e) => e ? Kn(e) : null
}), Zn = s((e) => e.__typename === "SportEvent" ? {
  type: "SportEvent",
  event: k({ data: e })
} : e.__typename === "SportTeamsEvent" ? {
  type: "SportTeamsEvent",
  event: ie({ data: e })
} : { event: null, type: null }), Jn = {
  name: "SportEvent",
  body: "query SportEvent($eventId: String!) { sportEvent(sportEventId: $eventId) { __typename ... on SportEvent { ...AbstractSportEvent } ... on SportTeamsEvent { ...AbstractSportEvent firstTeam { ...SportTeam } secondTeam { ...SportTeam } } } } fragment AbstractSportEvent on AbstractSportEvent { id sportEventId startTime endTime expirationTime title description shortDescription comment competition { ...SportCompetition } gallery { covers { announce { ...Image } live { ...Image } record { ...Image } accentRight { ...Image } accentRightSquare { ...Image } } posters { announceHorizontal { ...Image } liveHorizontal { ...Image } recordHorizontal { ...Image } accentRightHorizontal { ...Image } accentRightWithLogo { ...Image } } } liveMeta { ...AbstractSportEventLiveMeta } viewOption { ...SportViewOption } } fragment SportCompetition on Competition { id name shortName sportType { ...SportType } gallery { backgrounds { accentRight { ...Image } accentRightSquare { ...Image } } covers { clean { ...Image } main { ...Image } } logos { main { ...Image } } } } fragment SportType on SportType { id name } fragment Image on Image { avatarsUrl fallbackUrl } fragment AbstractSportEventLiveMeta on AbstractSportEventLiveMeta { stage } fragment SportViewOption on ViewOption { type purchasabilityStatus contentPackageToBuy { billingFeatureName } subscriptionBadge { image { ...Image } } } fragment SportTeam on SportTeam { id logo { ...Image } name fullName sportType { ...SportType } }",
  get variables() {
  },
  get query() {
  }
}, Zo = p(Jn, {
  resolve: (e) => e == null ? void 0 : e.sportEvent,
  hydrate: (e) => e ? Zn(e) : null
});
export {
  to as $,
  Oo as A,
  Ao as B,
  Ro as C,
  _o as D,
  $o as E,
  Eo as F,
  Wo as G,
  Lo as H,
  Uo as I,
  Do as J,
  Bo as K,
  ko as L,
  I as M,
  No as N,
  Vo as O,
  Fo as P,
  zo as Q,
  xo as R,
  Ho as S,
  Yo as T,
  Qo as U,
  Go as V,
  Xo as W,
  Ko as X,
  jo as Y,
  Zo as Z,
  Yn as _,
  Q as a,
  no as a0,
  oo as a1,
  St as a2,
  dt as a3,
  vt as a4,
  pt as a5,
  ut as a6,
  gt as a7,
  ft as a8,
  Cn as b,
  Ye as c,
  On as d,
  io as e,
  ro as f,
  ao as g,
  so as h,
  lo as i,
  co as j,
  mo as k,
  go as l,
  uo as m,
  po as n,
  vo as o,
  ho as p,
  fo as q,
  So as r,
  yo as s,
  Io as t,
  bo as u,
  wo as v,
  To as w,
  Po as x,
  Mo as y,
  Co as z
};
